import React, { useState } from 'react';
import usePoses from '../../../hooks/usePoses'; 

import extrastyles from './AbsolutePosImgs.scss';
import useBackgrounds from '../../../hooks/useBackgrounds';
import usePricelist from '../../../hooks/usePricelist';
import useMultiSeasonPoses from "../../../hooks/useMultiSeasonPoses";
import watermarkImage from './Watermark_v2.png';
import horizWatermarkImage from './Horiz_Grad_Watermark.png';


/*import StandardBackground from './Standard.png'; //1705
import EconomyBackground from './Economy.png'; //1708
import ScholarsChoiceBackground from './ScholarsChoice.png';//1711*/

const AbsolutePosImgs = ( customer, packageId, option) => {
  //const { data: poses } = usePoses(customer.currentStudent.id, packageId);
  const { data: pricelist } = usePricelist(packageId);
  const { data: poses } = pricelist?.id && (pricelist?.multipleSeasons?.length || pricelist?.displaySharedPoses) ? (
    useMultiSeasonPoses(customer.currentStudent.id, packageId)
  ) : (
  usePoses(customer.currentStudent.id, packageId)
)
  const hostname = window.location.hostname;
  const { data: backgrounds } = useBackgrounds(packageId);
  const { data: springbackgrounds } = useBackgrounds(packageId);

  // ADD THIS CHECK AT THE TOP
  // Check if poses exist and if all are .jpg files
  if (poses && poses.length > 0) {
    const allJpg = poses.every(pose => pose.imageUrl && pose.imageUrl.includes('.jpg'));
    if (allJpg) {
      return null;
    }
  }

  // If poses don't exist yet, don't render
  if (!poses || poses.length === 0) {
    return null;
  }

  // Rest of your component code continues here...
  const top_percentages = {
    // ... all your code
    '629 - Basic - 1': '11%',
    '629 - Basic - 2': '11%',
    '629 - Basic - 3': '11%',
    '629 - Basic - 4': '11%',
    '629 - Basic - 5': '29%',
    '629 - Basic - 6': '29%',
    '629 - Basic - 7': '29%',
    '629 - Basic - 8': '29%',
    '629 - Basic - 9': '53%',
    '629 - Basic - 10': '53%',
    '629 - Basic - 11': '28%',
    '629 - Basic - 12': '62%',
    '629 - Basic - 13': '62%',
    '629 - Basic - 14': '76%',
    '629 - Basic - 15': '76%',

    '629 - Star - 1': '12%',
    '629 - Star - 2': '77%',
    '629 - Star - 3': '77%',
    '629 - Star - 4': '11%',
    '629 - Star - 5': '11%',
    '629 - Star - 6': '50%',
    '629 - Star - 7': '50%',
    '629 - Star - 8': '50%',
    '629 - Star - 9': '50%',
    '629 - Star - 10': '66%',
    '629 - Star - 11': '66%',
    '629 - Star - 12': '66%',
    '629 - Star - 13': '66%',
    '629 - Star - 14': '8%',
    '629 - Star - 15': '68%',
    '629 - Star - 16': '59%',

    '629 - Perfect - 1': '21%',
    '629 - Perfect - 2': '21%',
    '629 - Perfect - 3': '47%',
    '629 - Perfect - 4': '4%',
    '629 - Perfect - 5': '3%',
    '629 - Perfect - 6': '69%',
    '629 - Perfect - 7': '69%',
    '629 - Perfect - 8': '69%',
    '629 - Perfect - 9': '69%',

    '629 - Memo - 1': '12%',
    '629 - Memo - 2': '37%',
    '629 - Memo - 3': '16%',
    '629 - Memo - 4': '16%',
    '629 - Memo - 5': '34%',
    '629 - Memo - 6': '34%',
    '629 - Memo - 7': '55%',
    '629 - Memo - 8': '55%',
    '629 - Memo - 9': '73%',
    '629 - Memo - 10': '73%',
    '629 - Memo - 11': '13%',
    '629 - Memo - 12': '60%',
    '629 - Memo - 13': '60%',
    '629 - Memo - 14': '74%',
    '629 - Memo - 15': '74%',

    '629 - Days - 1': '28%',
    '629 - Days - 2': '14%',
    '629 - Days - 3': '15%',

    '629 - Just - 1': '28%',
    '629 - Just - 2': '34%',
    '629 - Just - 3': '29%',

    '629 - Digital - 1': '32%',
    '629 - Digital - 2': '11%',

    '616 - Star - 1': '28%',
    '616 - Star - 2': '19%',
    '616 - Star - 3': '19%',
    '616 - Star - 4': '61%',
    '616 - Star - 5': '61%',
    '616 - Star - 6': '61%',
    '616 - Star - 7': '61%',
    '616 - Star - 8': '77%',
    '616 - Star - 9': '77%',
    '616 - Star - 10': '77%',
    '616 - Star - 11': '77%',
    '616 - Star - 12': '67%',
    '616 - Star - 13': '54%',

    '616 - Memories - 1': '19%',
    '616 - Memories - 2': '19%',
    '616 - Memories - 3': '71%',
    '616 - Memories - 4': '61%',
    '616 - Memories - 5': '61%',
    '616 - Memories - 6': '61%',
    '616 - Memories - 7': '61%',
    '616 - Memories - 8': '77%',
    '616 - Memories - 9': '77%',
    '616 - Memories - 10': '77%',
    '616 - Memories - 11': '77%',
    '616 - Memories - 12': '35%',
    '616 - Memories - 13': '53%',

    '616 - Picture - 1': '28%',
    '616 - Picture - 2': '19%',
    '616 - Picture - 3': '19%',
    '616 - Picture - 4': '61%',
    '616 - Picture - 5': '61%',
    '616 - Picture - 6': '61%',
    '616 - Picture - 7': '61%',
    '616 - Picture - 8': '77%',
    '616 - Picture - 9': '77%',
    '616 - Picture - 10': '77%',
    '616 - Picture - 11': '77%',
    '616 - Picture - 12': '69%',
    '616 - Picture - 13': '53%',

    '616 - Basic - 1': '12%',
    '616 - Basic - 2': '12%',
    '616 - Basic - 3': '12%',
    '616 - Basic - 4': '12%',
    '616 - Basic - 5': '29%',
    '616 - Basic - 6': '29%',
    '616 - Basic - 7': '29%',
    '616 - Basic - 8': '29%',
    '616 - Basic - 9': '53%',
    '616 - Basic - 10': '53%',
    '616 - Basic - 11': '40%',
    '616 - Basic - 12': '40%',
    '616 - Basic - 13': '64%',
    '616 - Basic - 14': '64%',

    '616 - School - 1': '25%',
    '616 - School - 2': '50%',
    '616 - School - 3': '50%',
    '616 - School - 4': '49%',

    '611 - Star - 1': '28%',
    '611 - Star - 2': '19%',
    '611 - Star - 3': '19%',
    '611 - Star - 4': '61%',
    '611 - Star - 5': '61%',
    '611 - Star - 6': '61%',
    '611 - Star - 7': '61%',
    '611 - Star - 8': '77%',
    '611 - Star - 9': '77%',
    '611 - Star - 10': '77%',
    '611 - Star - 11': '77%',
    '611 - Star - 12': '67%',
    '611 - Star - 13': '54%',

    '611 - Memories - 1': '19%',
    '611 - Memories - 2': '19%',
    '611 - Memories - 3': '71%',
    '611 - Memories - 4': '61%',
    '611 - Memories - 5': '61%',
    '611 - Memories - 6': '61%',
    '611 - Memories - 7': '61%',
    '611 - Memories - 8': '77%',
    '611 - Memories - 9': '77%',
    '611 - Memories - 10': '77%',
    '611 - Memories - 11': '77%',
    '611 - Memories - 12': '35%',
    '611 - Memories - 13': '53%',

    '611 - Picture - 1': '28%',
    '611 - Picture - 2': '19%',
    '611 - Picture - 3': '19%',
    '611 - Picture - 4': '61%',
    '611 - Picture - 5': '61%',
    '611 - Picture - 6': '61%',
    '611 - Picture - 7': '61%',
    '611 - Picture - 8': '77%',
    '611 - Picture - 9': '77%',
    '611 - Picture - 10': '77%',
    '611 - Picture - 11': '77%',
    '611 - Picture - 12': '69%',
    '611 - Picture - 13': '53%',

    '611 - Basic - 1': '12%',
    '611 - Basic - 2': '12%',
    '611 - Basic - 3': '12%',
    '611 - Basic - 4': '12%',
    '611 - Basic - 5': '29%',
    '611 - Basic - 6': '29%',
    '611 - Basic - 7': '29%',
    '611 - Basic - 8': '29%',
    '611 - Basic - 9': '53%',
    '611 - Basic - 10': '53%',
    '611 - Basic - 11': '40%',
    '611 - Basic - 12': '40%',
    '611 - Basic - 13': '64%',
    '611 - Basic - 14': '64%',

    '611 - School - 1': '25%',
    '611 - School - 2': '50%',
    '611 - School - 3': '50%',
    '611 - School - 4': '49%',

    '611 - 8x10 - 1': '13%',

    '616 - 8x10 - 1': '12%',

    '549 - Star - 1': '28%',
    '549 - Star - 2': '19%',
    '549 - Star - 3': '19%',
    '549 - Star - 4': '61%',
    '549 - Star - 5': '61%',
    '549 - Star - 6': '61%',
    '549 - Star - 7': '61%',
    '549 - Star - 8': '77%',
    '549 - Star - 9': '77%',
    '549 - Star - 10': '77%',
    '549 - Star - 11': '77%',
    '549 - Star - 12': '67%',
    '549 - Star - 13': '54%',

    '549 - Memories - 1': '19%',
    '549 - Memories - 2': '19%',
    '549 - Memories - 3': '71%',
    '549 - Memories - 4': '61%',
    '549 - Memories - 5': '61%',
    '549 - Memories - 6': '61%',
    '549 - Memories - 7': '61%',
    '549 - Memories - 8': '77%',
    '549 - Memories - 9': '77%',
    '549 - Memories - 10': '77%',
    '549 - Memories - 11': '77%',
    '549 - Memories - 12': '35%',
    '549 - Memories - 13': '53%',

    '549 - Picture - 1': '28%',
    '549 - Picture - 2': '19%',
    '549 - Picture - 3': '19%',
    '549 - Picture - 4': '61%',
    '549 - Picture - 5': '61%',
    '549 - Picture - 6': '61%',
    '549 - Picture - 7': '61%',
    '549 - Picture - 8': '77%',
    '549 - Picture - 9': '77%',
    '549 - Picture - 10': '77%',
    '549 - Picture - 11': '77%',
    '549 - Picture - 12': '69%',
    '549 - Picture - 13': '53%',

    '549 - Basic - 1': '12%',
    '549 - Basic - 2': '12%',
    '549 - Basic - 3': '12%',
    '549 - Basic - 4': '12%',
    '549 - Basic - 5': '29%',
    '549 - Basic - 6': '29%',
    '549 - Basic - 7': '29%',
    '549 - Basic - 8': '29%',
    '549 - Basic - 9': '53%',
    '549 - Basic - 10': '53%',
    '549 - Basic - 11': '40%',
    '549 - Basic - 12': '40%',
    '549 - Basic - 13': '64%',
    '549 - Basic - 14': '64%',

    '549 - School - 1': '25%',
    '549 - School - 2': '50%',
    '549 - School - 3': '50%',
    '549 - School - 4': '49%',

    '550 - Star - 1': '28%',
    '550 - Star - 2': '19%',
    '550 - Star - 3': '19%',
    '550 - Star - 4': '61%',
    '550 - Star - 5': '61%',
    '550 - Star - 6': '61%',
    '550 - Star - 7': '61%',
    '550 - Star - 8': '77%',
    '550 - Star - 9': '77%',
    '550 - Star - 10': '77%',
    '550 - Star - 11': '77%',
    '550 - Star - 12': '67%',
    '550 - Star - 13': '54%',

    '550 - Memories - 1': '19%',
    '550 - Memories - 2': '19%',
    '550 - Memories - 3': '71%',
    '550 - Memories - 4': '61%',
    '550 - Memories - 5': '61%',
    '550 - Memories - 6': '61%',
    '550 - Memories - 7': '61%',
    '550 - Memories - 8': '77%',
    '550 - Memories - 9': '77%',
    '550 - Memories - 10': '77%',
    '550 - Memories - 11': '77%',
    '550 - Memories - 12': '35%',
    '550 - Memories - 13': '53%',

    '550 - Picture - 1': '28%',
    '550 - Picture - 2': '19%',
    '550 - Picture - 3': '19%',
    '550 - Picture - 4': '61%',
    '550 - Picture - 5': '61%',
    '550 - Picture - 6': '61%',
    '550 - Picture - 7': '61%',
    '550 - Picture - 8': '77%',
    '550 - Picture - 9': '77%',
    '550 - Picture - 10': '77%',
    '550 - Picture - 11': '77%',
    '550 - Picture - 12': '69%',
    '550 - Picture - 13': '53%',

    '550 - Basic - 1': '12%',
    '550 - Basic - 2': '12%',
    '550 - Basic - 3': '12%',
    '550 - Basic - 4': '12%',
    '550 - Basic - 5': '29%',
    '550 - Basic - 6': '29%',
    '550 - Basic - 7': '29%',
    '550 - Basic - 8': '29%',
    '550 - Basic - 9': '53%',
    '550 - Basic - 10': '53%',
    '550 - Basic - 11': '40%',
    '550 - Basic - 12': '40%',
    '550 - Basic - 13': '64%',
    '550 - Basic - 14': '64%',

    '550 - School - 1': '25%',
    '550 - School - 2': '50%',
    '550 - School - 3': '50%',
    '550 - School - 4': '49%',

    '550 - 8x10 - 1': '13%',

    '549 - 8x10 - 1': '12%',


  };

  const left_percentages = {
    '629 - Basic - 1': '18%',
    '629 - Basic - 2': '25%',
    '629 - Basic - 3': '35%',
    '629 - Basic - 4': '43%',
    '629 - Basic - 5': '18%',
    '629 - Basic - 6': '25%',
    '629 - Basic - 7': '35%',
    '629 - Basic - 8': '43%',
    '629 - Basic - 9': '19%',
    '629 - Basic - 10': '39%',
    '629 - Basic - 11': '61%',
    '629 - Basic - 12': '67%',
    '629 - Basic - 13': '76%',
    '629 - Basic - 14': '67%',
    '629 - Basic - 15': '76%',

    '629 - Star - 1': '6%',
    '629 - Star - 2': '7%',
    '629 - Star - 3': '20%',
    '629 - Star - 4': '35%',
    '629 - Star - 5': '49%',
    '629 - Star - 6': '35%',
    '629 - Star - 7': '41%',
    '629 - Star - 8': '48%',
    '629 - Star - 9': '55%',
    '629 - Star - 10': '35%',
    '629 - Star - 11': '41%',
    '629 - Star - 12': '48%',
    '629 - Star - 13': '55%',
    '629 - Star - 14': '65%',
    '629 - Star - 15': '66%',
    '629 - Star - 16': '79%',

    '629 - Perfect - 1': '5%',
    '629 - Perfect - 2': '23%',
    '629 - Perfect - 3': '4%',
    '629 - Perfect - 4': '41%',
    '629 - Perfect - 5': '69%',
    '629 - Perfect - 6': '42%',
    '629 - Perfect - 7': '56%',
    '629 - Perfect - 8': '70%',
    '629 - Perfect - 9': '84%',

    '629 - Memo - 1': '3%',
    '629 - Memo - 2': '27%',
    '629 - Memo - 3': '52%',
    '629 - Memo - 4': '60%',
    '629 - Memo - 5': '52%',
    '629 - Memo - 6': '60%',
    '629 - Memo - 7': '52%',
    '629 - Memo - 8': '60%',
    '629 - Memo - 9': '52%',
    '629 - Memo - 10': '60%',
    '629 - Memo - 11': '69%',
    '629 - Memo - 12': '74%',
    '629 - Memo - 13': '83%',
    '629 - Memo - 14': '74%',
    '629 - Memo - 15': '83%',

    '629 - Days - 1': '5%',
    '629 - Days - 2': '40%',
    '629 - Days - 3': '69%',

    '629 - Just - 1': '5%',
    '629 - Just - 2': '33%',
    '629 - Just - 3': '69%',

    '629 - Digital - 1': '6%',
    '629 - Digital - 2': '32%',

    '616 - Star - 1': '7%',
    '616 - Star - 2': '36%',
    '616 - Star - 3': '52%',
    '616 - Star - 4': '35%',
    '616 - Star - 5': '42%',
    '616 - Star - 6': '49%',
    '616 - Star - 7': '56%',
    '616 - Star - 8': '35%',
    '616 - Star - 9': '42%',
    '616 - Star - 10': '49%',
    '616 - Star - 11': '56%',
    '616 - Star - 12': '68%',
    '616 - Star - 13': '82%',

    '616 - Memories - 1': '10%',
    '616 - Memories - 2': '25%',
    '616 - Memories - 3': '6%',
    '616 - Memories - 4': '18%',
    '616 - Memories - 5': '25%',
    '616 - Memories - 6': '31%',
    '616 - Memories - 7': '38%',
    '616 - Memories - 8': '18%',
    '616 - Memories - 9': '25%',
    '616 - Memories - 10': '31%',
    '616 - Memories - 11': '38%',
    '616 - Memories - 12': '51%',
    '616 - Memories - 13': '82%',

    '616 - Picture - 1': '7%',
    '616 - Picture - 2': '36%',
    '616 - Picture - 3': '52%',
    '616 - Picture - 4': '36%',
    '616 - Picture - 5': '42%',
    '616 - Picture - 6': '49%',
    '616 - Picture - 7': '56%',
    '616 - Picture - 8': '36%',
    '616 - Picture - 9': '42%',
    '616 - Picture - 10': '49%',
    '616 - Picture - 11': '56%',
    '616 - Picture - 12': '68%',
    '616 - Picture - 13': '82%',

    '616 - Basic - 1': '25%',
    '616 - Basic - 2': '32%',
    '616 - Basic - 3': '39%',
    '616 - Basic - 4': '46%',
    '616 - Basic - 5': '25%',
    '616 - Basic - 6': '32%',
    '616 - Basic - 7': '39%',
    '616 - Basic - 8': '46%',
    '616 - Basic - 9': '19%',
    '616 - Basic - 10': '35%',
    '616 - Basic - 11': '57%',
    '616 - Basic - 12': '68%',
    '616 - Basic - 13': '57%',
    '616 - Basic - 14': '68%',

    '616 - School - 1': '8%',
    '616 - School - 2': '40%',
    '616 - School - 3': '55%',
    '616 - School - 4': '77%',

    '611 - Star - 1': '7%',
    '611 - Star - 2': '36%',
    '611 - Star - 3': '52%',
    '611 - Star - 4': '35%',
    '611 - Star - 5': '42%',
    '611 - Star - 6': '49%',
    '611 - Star - 7': '56%',
    '611 - Star - 8': '35%',
    '611 - Star - 9': '42%',
    '611 - Star - 10': '49%',
    '611 - Star - 11': '56%',
    '611 - Star - 12': '68%',
    '611 - Star - 13': '82%',

    '611 - Memories - 1': '10%',
    '611 - Memories - 2': '25%',
    '611 - Memories - 3': '6%',
    '611 - Memories - 4': '18%',
    '611 - Memories - 5': '25%',
    '611 - Memories - 6': '31%',
    '611 - Memories - 7': '38%',
    '611 - Memories - 8': '18%',
    '611 - Memories - 9': '25%',
    '611 - Memories - 10': '31%',
    '611 - Memories - 11': '38%',
    '611 - Memories - 12': '51%',
    '611 - Memories - 13': '82%',

    '611 - Picture - 1': '7%',
    '611 - Picture - 2': '36%',
    '611 - Picture - 3': '52%',
    '611 - Picture - 4': '36%',
    '611 - Picture - 5': '42%',
    '611 - Picture - 6': '49%',
    '611 - Picture - 7': '56%',
    '611 - Picture - 8': '36%',
    '611 - Picture - 9': '42%',
    '611 - Picture - 10': '49%',
    '611 - Picture - 11': '56%',
    '611 - Picture - 12': '68%',
    '611 - Picture - 13': '82%',

    '611 - Basic - 1': '25%',
    '611 - Basic - 2': '32%',
    '611 - Basic - 3': '39%',
    '611 - Basic - 4': '46%',
    '611 - Basic - 5': '25%',
    '611 - Basic - 6': '32%',
    '611 - Basic - 7': '39%',
    '611 - Basic - 8': '46%',
    '611 - Basic - 9': '19%',
    '611 - Basic - 10': '35%',
    '611 - Basic - 11': '57%',
    '611 - Basic - 12': '68%',
    '611 - Basic - 13': '57%',
    '611 - Basic - 14': '68%',

    '611 - School - 1': '8%',
    '611 - School - 2': '40%',
    '611 - School - 3': '55%',
    '611 - School - 4': '77%',

    '611 - 8x10 - 1': '33%',

    '616 - 8x10 - 1': '33%',
    
    '549 - Star - 1': '7%',
    '549 - Star - 2': '36%',
    '549 - Star - 3': '52%',
    '549 - Star - 4': '35%',
    '549 - Star - 5': '42%',
    '549 - Star - 6': '49%',
    '549 - Star - 7': '56%',
    '549 - Star - 8': '35%',
    '549 - Star - 9': '42%',
    '549 - Star - 10': '49%',
    '549 - Star - 11': '56%',
    '549 - Star - 12': '68%',
    '549 - Star - 13': '82%',

    '549 - Memories - 1': '10%',
    '549 - Memories - 2': '25%',
    '549 - Memories - 3': '6%',
    '549 - Memories - 4': '18%',
    '549 - Memories - 5': '25%',
    '549 - Memories - 6': '31%',
    '549 - Memories - 7': '38%',
    '549 - Memories - 8': '18%',
    '549 - Memories - 9': '25%',
    '549 - Memories - 10': '31%',
    '549 - Memories - 11': '38%',
    '549 - Memories - 12': '51%',
    '549 - Memories - 13': '82%',

    '549 - Picture - 1': '7%',
    '549 - Picture - 2': '36%',
    '549 - Picture - 3': '52%',
    '549 - Picture - 4': '36%',
    '549 - Picture - 5': '42%',
    '549 - Picture - 6': '49%',
    '549 - Picture - 7': '56%',
    '549 - Picture - 8': '36%',
    '549 - Picture - 9': '42%',
    '549 - Picture - 10': '49%',
    '549 - Picture - 11': '56%',
    '549 - Picture - 12': '68%',
    '549 - Picture - 13': '82%',

    '549 - Basic - 1': '25%',
    '549 - Basic - 2': '32%',
    '549 - Basic - 3': '39%',
    '549 - Basic - 4': '46%',
    '549 - Basic - 5': '25%',
    '549 - Basic - 6': '32%',
    '549 - Basic - 7': '39%',
    '549 - Basic - 8': '46%',
    '549 - Basic - 9': '19%',
    '549 - Basic - 10': '35%',
    '549 - Basic - 11': '57%',
    '549 - Basic - 12': '68%',
    '549 - Basic - 13': '57%',
    '549 - Basic - 14': '68%',

    '549 - School - 1': '8%',
    '549 - School - 2': '40%',
    '549 - School - 3': '55%',
    '549 - School - 4': '77%',

    '550 - Star - 1': '7%',
    '550 - Star - 2': '36%',
    '550 - Star - 3': '52%',
    '550 - Star - 4': '35%',
    '550 - Star - 5': '42%',
    '550 - Star - 6': '49%',
    '550 - Star - 7': '56%',
    '550 - Star - 8': '35%',
    '550 - Star - 9': '42%',
    '550 - Star - 10': '49%',
    '550 - Star - 11': '56%',
    '550 - Star - 12': '68%',
    '550 - Star - 13': '82%',

    '550 - Memories - 1': '10%',
    '550 - Memories - 2': '25%',
    '550 - Memories - 3': '6%',
    '550 - Memories - 4': '18%',
    '550 - Memories - 5': '25%',
    '550 - Memories - 6': '31%',
    '550 - Memories - 7': '38%',
    '550 - Memories - 8': '18%',
    '550 - Memories - 9': '25%',
    '550 - Memories - 10': '31%',
    '550 - Memories - 11': '38%',
    '550 - Memories - 12': '51%',
    '550 - Memories - 13': '82%',

    '550 - Picture - 1': '7%',
    '550 - Picture - 2': '36%',
    '550 - Picture - 3': '52%',
    '550 - Picture - 4': '36%',
    '550 - Picture - 5': '42%',
    '550 - Picture - 6': '49%',
    '550 - Picture - 7': '56%',
    '550 - Picture - 8': '36%',
    '550 - Picture - 9': '42%',
    '550 - Picture - 10': '49%',
    '550 - Picture - 11': '56%',
    '550 - Picture - 12': '68%',
    '550 - Picture - 13': '82%',

    '550 - Basic - 1': '25%',
    '550 - Basic - 2': '32%',
    '550 - Basic - 3': '39%',
    '550 - Basic - 4': '46%',
    '550 - Basic - 5': '25%',
    '550 - Basic - 6': '32%',
    '550 - Basic - 7': '39%',
    '550 - Basic - 8': '46%',
    '550 - Basic - 9': '19%',
    '550 - Basic - 10': '35%',
    '550 - Basic - 11': '57%',
    '550 - Basic - 12': '68%',
    '550 - Basic - 13': '57%',
    '550 - Basic - 14': '68%',

    '550 - School - 1': '8%',
    '550 - School - 2': '40%',
    '550 - School - 3': '55%',
    '550 - School - 4': '77%',

    '550 - 8x10 - 1': '33%',

    '549 - 8x10 - 1': '33%',
  };

  const width_percentages = {
    '629 - Basic - 1': '7%',
    '629 - Basic - 2': '7%',
    '629 - Basic - 3': '7%',
    '629 - Basic - 4': '7%',
    '629 - Basic - 5': '7%',
    '629 - Basic - 6': '7%',
    '629 - Basic - 7': '7%',
    '629 - Basic - 8': '7%',
    '629 - Basic - 9': '16%',
    '629 - Basic - 10': '16%',
    '629 - Basic - 11': '20%',
    '629 - Basic - 12': '9%',
    '629 - Basic - 13': '9%',
    '629 - Basic - 14': '9%',
    '629 - Basic - 15': '9%',

    '629 - Star - 1': '25%',
    '629 - Star - 2': '9%',
    '629 - Star - 3': '9%',
    '629 - Star - 4': '14%',
    '629 - Star - 5': '14%',
    '629 - Star - 6': '7%',
    '629 - Star - 7': '7%',
    '629 - Star - 8': '7%',
    '629 - Star - 9': '7%',
    '629 - Star - 10': '7%',
    '629 - Star - 11': '7%',
    '629 - Star - 12': '7%',
    '629 - Star - 13': '7%',
    '629 - Star - 14': '31%',
    '629 - Star - 15': '11%',
    '629 - Star - 16': '18%',

    '629 - Perfect - 1': '15%',
    '629 - Perfect - 2': '15%',
    '629 - Perfect - 3': '33%',
    '629 - Perfect - 4': '27%',
    '629 - Perfect - 5': '27%',
    '629 - Perfect - 6': '12%',
    '629 - Perfect - 7': '12%',
    '629 - Perfect - 8': '12%',
    '629 - Perfect - 9': '12%',

    '629 - Memo - 1': '23%',
    '629 - Memo - 2': '23%',
    '629 - Memo - 3': '7%',
    '629 - Memo - 4': '7%',
    '629 - Memo - 5': '7%',
    '629 - Memo - 6': '7%',
    '629 - Memo - 7': '7%',
    '629 - Memo - 8': '7%',
    '629 - Memo - 9': '7%',
    '629 - Memo - 10': '7%',
    '629 - Memo - 11': '28%',
    '629 - Memo - 12': '10%',
    '629 - Memo - 13': '10%',
    '629 - Memo - 14': '10%',
    '629 - Memo - 15': '10%',

    '629 - Days - 1': '33%',
    '629 - Days - 2': '27%',
    '629 - Days - 3': '26%',

    '629 - Just - 1': '27%',
    '629 - Just - 2': '33%',
    '629 - Just - 3': '26%',

    '629 - Digital - 1': '19%',
    '629 - Digital - 2': '38%',

    '611 - Star - 1': '25%',
    '611 - Star - 2': '15%',
    '611 - Star - 3': '15%',
    '611 - Star - 4': '7%',
    '611 - Star - 5': '7%',
    '611 - Star - 6': '7%',
    '611 - Star - 7': '7%',
    '611 - Star - 8': '7%',
    '611 - Star - 9': '7%',
    '611 - Star - 10': '7%',
    '611 - Star - 11': '7%',
    '611 - Star - 12': '10%',
    '611 - Star - 13': '12%',

    '611 - Memories - 1': '15%',
    '611 - Memories - 2': '15%',
    '611 - Memories - 3': '10%',
    '611 - Memories - 4': '7%',
    '611 - Memories - 5': '7%',
    '611 - Memories - 6': '7%',
    '611 - Memories - 7': '7%',
    '611 - Memories - 8': '7%',
    '611 - Memories - 9': '7%',
    '611 - Memories - 10': '7%',
    '611 - Memories - 11': '7%',
    '611 - Memories - 12': '25%',
    '611 - Memories - 13': '12%',

    '611 - Picture - 1': '25%',
    '611 - Picture - 2': '15%',
    '611 - Picture - 3': '15%',
    '611 - Picture - 4': '7%',
    '611 - Picture - 5': '7%',
    '611 - Picture - 6': '7%',
    '611 - Picture - 7': '7%',
    '611 - Picture - 8': '7%',
    '611 - Picture - 9': '7%',
    '611 - Picture - 10': '7%',
    '611 - Picture - 11': '7%',
    '611 - Picture - 12': '10%',
    '611 - Picture - 13': '12%',

    '611 - Basic - 1': '7%',
    '611 - Basic - 2': '7%',
    '611 - Basic - 3': '7%',
    '611 - Basic - 4': '7%',
    '611 - Basic - 5': '7%',
    '611 - Basic - 6': '7%',
    '611 - Basic - 7': '7%',
    '611 - Basic - 8': '7%',
    '611 - Basic - 9': '17%',
    '611 - Basic - 10': '17%',
    '611 - Basic - 11': '11%',
    '611 - Basic - 12': '11%',
    '611 - Basic - 13': '11%',
    '611 - Basic - 14': '11%',

    '611 - School - 1': '27%',
    '611 - School - 2': '15%',
    '611 - School - 3': '15%',
    '611 - School - 4': '12%',

    '616 - Star - 1': '25%',
    '616 - Star - 2': '15%',
    '616 - Star - 3': '15%',
    '616 - Star - 4': '7%',
    '616 - Star - 5': '7%',
    '616 - Star - 6': '7%',
    '616 - Star - 7': '7%',
    '616 - Star - 8': '7%',
    '616 - Star - 9': '7%',
    '616 - Star - 10': '7%',
    '616 - Star - 11': '7%',
    '616 - Star - 12': '10%',
    '616 - Star - 13': '12%',

    '616 - Memories - 1': '15%',
    '616 - Memories - 2': '15%',
    '616 - Memories - 3': '10%',
    '616 - Memories - 4': '7%',
    '616 - Memories - 5': '7%',
    '616 - Memories - 6': '7%',
    '616 - Memories - 7': '7%',
    '616 - Memories - 8': '7%',
    '616 - Memories - 9': '7%',
    '616 - Memories - 10': '7%',
    '616 - Memories - 11': '7%',
    '616 - Memories - 12': '25%',
    '616 - Memories - 13': '12%',

    '616 - Picture - 1': '25%',
    '616 - Picture - 2': '15%',
    '616 - Picture - 3': '15%',
    '616 - Picture - 4': '7%',
    '616 - Picture - 5': '7%',
    '616 - Picture - 6': '7%',
    '616 - Picture - 7': '7%',
    '616 - Picture - 8': '7%',
    '616 - Picture - 9': '7%',
    '616 - Picture - 10': '7%',
    '616 - Picture - 11': '7%',
    '616 - Picture - 12': '10%',
    '616 - Picture - 13': '12%',

    '616 - Basic - 1': '7%',
    '616 - Basic - 2': '7%',
    '616 - Basic - 3': '7%',
    '616 - Basic - 4': '7%',
    '616 - Basic - 5': '7%',
    '616 - Basic - 6': '7%',
    '616 - Basic - 7': '7%',
    '616 - Basic - 8': '7%',
    '616 - Basic - 9': '17%',
    '616 - Basic - 10': '17%',
    '616 - Basic - 11': '11%',
    '616 - Basic - 12': '11%',
    '616 - Basic - 13': '11%',
    '616 - Basic - 14': '11%',

    '616 - School - 1': '27%',
    '616 - School - 2': '15%',
    '616 - School - 3': '15%',
    '616 - School - 4': '12%',

    '611 - 8x10 - 1': '34%',

    '616 - 8x10 - 1': '35%',

    '550 - Star - 1': '25%',
    '550 - Star - 2': '15%',
    '550 - Star - 3': '15%',
    '550 - Star - 4': '7%',
    '550 - Star - 5': '7%',
    '550 - Star - 6': '7%',
    '550 - Star - 7': '7%',
    '550 - Star - 8': '7%',
    '550 - Star - 9': '7%',
    '550 - Star - 10': '7%',
    '550 - Star - 11': '7%',
    '550 - Star - 12': '10%',
    '550 - Star - 13': '12%',

    '550 - Memories - 1': '15%',
    '550 - Memories - 2': '15%',
    '550 - Memories - 3': '10%',
    '550 - Memories - 4': '7%',
    '550 - Memories - 5': '7%',
    '550 - Memories - 6': '7%',
    '550 - Memories - 7': '7%',
    '550 - Memories - 8': '7%',
    '550 - Memories - 9': '7%',
    '550 - Memories - 10': '7%',
    '550 - Memories - 11': '7%',
    '550 - Memories - 12': '25%',
    '550 - Memories - 13': '12%',

    '550 - Picture - 1': '25%',
    '550 - Picture - 2': '15%',
    '550 - Picture - 3': '15%',
    '550 - Picture - 4': '7%',
    '550 - Picture - 5': '7%',
    '550 - Picture - 6': '7%',
    '550 - Picture - 7': '7%',
    '550 - Picture - 8': '7%',
    '550 - Picture - 9': '7%',
    '550 - Picture - 10': '7%',
    '550 - Picture - 11': '7%',
    '550 - Picture - 12': '10%',
    '550 - Picture - 13': '12%',

    '550 - Basic - 1': '7%',
    '550 - Basic - 2': '7%',
    '550 - Basic - 3': '7%',
    '550 - Basic - 4': '7%',
    '550 - Basic - 5': '7%',
    '550 - Basic - 6': '7%',
    '550 - Basic - 7': '7%',
    '550 - Basic - 8': '7%',
    '550 - Basic - 9': '17%',
    '550 - Basic - 10': '17%',
    '550 - Basic - 11': '11%',
    '550 - Basic - 12': '11%',
    '550 - Basic - 13': '11%',
    '550 - Basic - 14': '11%',

    '550 - School - 1': '27%',
    '550 - School - 2': '15%',
    '550 - School - 3': '15%',
    '550 - School - 4': '12%',

    '549 - Star - 1': '25%',
    '549 - Star - 2': '15%',
    '549 - Star - 3': '15%',
    '549 - Star - 4': '7%',
    '549 - Star - 5': '7%',
    '549 - Star - 6': '7%',
    '549 - Star - 7': '7%',
    '549 - Star - 8': '7%',
    '549 - Star - 9': '7%',
    '549 - Star - 10': '7%',
    '549 - Star - 11': '7%',
    '549 - Star - 12': '10%',
    '549 - Star - 13': '12%',

    '549 - Memories - 1': '15%',
    '549 - Memories - 2': '15%',
    '549 - Memories - 3': '10%',
    '549 - Memories - 4': '7%',
    '549 - Memories - 5': '7%',
    '549 - Memories - 6': '7%',
    '549 - Memories - 7': '7%',
    '549 - Memories - 8': '7%',
    '549 - Memories - 9': '7%',
    '549 - Memories - 10': '7%',
    '549 - Memories - 11': '7%',
    '549 - Memories - 12': '25%',
    '549 - Memories - 13': '12%',

    '549 - Picture - 1': '25%',
    '549 - Picture - 2': '15%',
    '549 - Picture - 3': '15%',
    '549 - Picture - 4': '7%',
    '549 - Picture - 5': '7%',
    '549 - Picture - 6': '7%',
    '549 - Picture - 7': '7%',
    '549 - Picture - 8': '7%',
    '549 - Picture - 9': '7%',
    '549 - Picture - 10': '7%',
    '549 - Picture - 11': '7%',
    '549 - Picture - 12': '10%',
    '549 - Picture - 13': '12%',

    '549 - Basic - 1': '7%',
    '549 - Basic - 2': '7%',
    '549 - Basic - 3': '7%',
    '549 - Basic - 4': '7%',
    '549 - Basic - 5': '7%',
    '549 - Basic - 6': '7%',
    '549 - Basic - 7': '7%',
    '549 - Basic - 8': '7%',
    '549 - Basic - 9': '17%',
    '549 - Basic - 10': '17%',
    '549 - Basic - 11': '11%',
    '549 - Basic - 12': '11%',
    '549 - Basic - 13': '11%',
    '549 - Basic - 14': '11%',

    '549 - School - 1': '27%',
    '549 - School - 2': '15%',
    '549 - School - 3': '15%',
    '549 - School - 4': '12%',

    '550 - 8x10 - 1': '34%',

    '549 - 8x10 - 1': '35%',
  };

  const display_types = {
    '629 - Basic - 1': 'block',
    '629 - Basic - 2': 'block',
    '629 - Basic - 3': 'block',
    '629 - Basic - 4': 'block',
    '629 - Basic - 5': 'block',
    '629 - Basic - 6': 'block',
    '629 - Basic - 7': 'block',
    '629 - Basic - 8': 'block',
    '629 - Basic - 9': 'block',
    '629 - Basic - 10': 'block',
    '629 - Basic - 11': 'block',
    '629 - Basic - 12': 'block',
    '629 - Basic - 13': 'block',
    '629 - Basic - 14': 'block',
    '629 - Basic - 15': 'block',

    '629 - Star - 1': 'block',
    '629 - Star - 2': 'block',
    '629 - Star - 3': 'block',
    '629 - Star - 4': 'block',
    '629 - Star - 5': 'block',
    '629 - Star - 6': 'block',
    '629 - Star - 7': 'block',
    '629 - Star - 8': 'block',
    '629 - Star - 9': 'block',
    '629 - Star - 10': 'block',
    '629 - Star - 11': 'block',
    '629 - Star - 12': 'block',
    '629 - Star - 13': 'block',
    '629 - Star - 14': 'block',
    '629 - Star - 15': 'block',
    '629 - Star - 16': 'block',

    '629 - Perfect - 1': 'block',
    '629 - Perfect - 2': 'block',
    '629 - Perfect - 3': 'block',
    '629 - Perfect - 4': 'block',
    '629 - Perfect - 5': 'block',
    '629 - Perfect - 6': 'block',
    '629 - Perfect - 7': 'block',
    '629 - Perfect - 8': 'block',
    '629 - Perfect - 9': 'block',

    '629 - Memo - 1': 'block',
    '629 - Memo - 2': 'block',
    '629 - Memo - 3': 'block',
    '629 - Memo - 4': 'block',
    '629 - Memo - 5': 'block',
    '629 - Memo - 6': 'block',
    '629 - Memo - 7': 'block',
    '629 - Memo - 8': 'block',
    '629 - Memo - 9': 'block',
    '629 - Memo - 10': 'block',
    '629 - Memo - 11': 'block',
    '629 - Memo - 12': 'block',
    '629 - Memo - 13': 'block',
    '629 - Memo - 14': 'block',
    '629 - Memo - 15': 'block',

    '629 - Days - 1': 'block',
    '629 - Days - 2': 'block',
    '629 - Days - 3': 'block',

    '629 - Just - 1': 'block',
    '629 - Just - 2': 'block',
    '629 - Just - 3': 'block',

    '629 - Digital - 1': 'block',
    '629 - Digital - 2': 'block',

    '616 - Star - 1': 'block',
    '616 - Star - 2': 'block',
    '616 - Star - 3': 'block',
    '616 - Star - 4': 'block',
    '616 - Star - 5': 'block',
    '616 - Star - 6': 'block',
    '616 - Star - 7': 'block',
    '616 - Star - 8': 'block',
    '616 - Star - 9': 'block',
    '616 - Star - 10': 'block',
    '616 - Star - 11': 'block',
    '616 - Star - 12': 'block',
    '616 - Star - 13': 'block',

    '616 - Memories - 1': 'block',
    '616 - Memories - 2': 'block',
    '616 - Memories - 3': 'block',
    '616 - Memories - 4': 'block',
    '616 - Memories - 5': 'block',
    '616 - Memories - 6': 'block',
    '616 - Memories - 7': 'block',
    '616 - Memories - 8': 'block',
    '616 - Memories - 9': 'block',
    '616 - Memories - 10': 'block',
    '616 - Memories - 11': 'block',
    '616 - Memories - 12': 'block',
    '616 - Memories - 13': 'block',

    '616 - Picture - 1': 'block',
    '616 - Picture - 2': 'block',
    '616 - Picture - 3': 'block',
    '616 - Picture - 4': 'block',
    '616 - Picture - 5': 'block',
    '616 - Picture - 6': 'block',
    '616 - Picture - 7': 'block',
    '616 - Picture - 8': 'block',
    '616 - Picture - 9': 'block',
    '616 - Picture - 10': 'block',
    '616 - Picture - 11': 'block',
    '616 - Picture - 12': 'block',
    '616 - Picture - 13': 'block',

    '616 - Basic - 1': 'block',
    '616 - Basic - 2': 'block',
    '616 - Basic - 3': 'block',
    '616 - Basic - 4': 'block',
    '616 - Basic - 5': 'block',
    '616 - Basic - 6': 'block',
    '616 - Basic - 7': 'block',
    '616 - Basic - 8': 'block',
    '616 - Basic - 9': 'block',
    '616 - Basic - 10': 'block',
    '616 - Basic - 11': 'block',
    '616 - Basic - 12': 'block',
    '616 - Basic - 13': 'block',
    '616 - Basic - 14': 'block',
    '616 - Basic - 15': 'none',
    '616 - Basic - 16': 'none',

    '616 - School - 1': 'block',
    '616 - School - 2': 'block',
    '616 - School - 3': 'block',
    '616 - School - 4': 'block',

    '611 - Star - 1': 'block',
    '611 - Star - 2': 'block',
    '611 - Star - 3': 'block',
    '611 - Star - 4': 'block',
    '611 - Star - 5': 'block',
    '611 - Star - 6': 'block',
    '611 - Star - 7': 'block',
    '611 - Star - 8': 'block',
    '611 - Star - 9': 'block',
    '611 - Star - 10': 'block',
    '611 - Star - 11': 'block',
    '611 - Star - 12': 'block',
    '611 - Star - 13': 'block',

    '611 - Memories - 1': 'block',
    '611 - Memories - 2': 'block',
    '611 - Memories - 3': 'block',
    '611 - Memories - 4': 'block',
    '611 - Memories - 5': 'block',
    '611 - Memories - 6': 'block',
    '611 - Memories - 7': 'block',
    '611 - Memories - 8': 'block',
    '611 - Memories - 9': 'block',
    '611 - Memories - 10': 'block',
    '611 - Memories - 11': 'block',
    '611 - Memories - 12': 'block',
    '611 - Memories - 13': 'block',

    '611 - Picture - 1': 'block',
    '611 - Picture - 2': 'block',
    '611 - Picture - 3': 'block',
    '611 - Picture - 4': 'block',
    '611 - Picture - 5': 'block',
    '611 - Picture - 6': 'block',
    '611 - Picture - 7': 'block',
    '611 - Picture - 8': 'block',
    '611 - Picture - 9': 'block',
    '611 - Picture - 10': 'block',
    '611 - Picture - 11': 'block',
    '611 - Picture - 12': 'block',
    '611 - Picture - 13': 'block',

    '611 - Basic - 1': 'block',
    '611 - Basic - 2': 'block',
    '611 - Basic - 3': 'block',
    '611 - Basic - 4': 'block',
    '611 - Basic - 5': 'block',
    '611 - Basic - 6': 'block',
    '611 - Basic - 7': 'block',
    '611 - Basic - 8': 'block',
    '611 - Basic - 9': 'block',
    '611 - Basic - 10': 'block',
    '611 - Basic - 11': 'block',
    '611 - Basic - 12': 'block',
    '611 - Basic - 13': 'block',
    '611 - Basic - 14': 'block',
    '611 - Basic - 15': 'none',
    '611 - Basic - 16': 'none',

    '611 - School - 1': 'block',
    '611 - School - 2': 'block',
    '611 - School - 3': 'block',
    '611 - School - 4': 'block',
    
    '611 - 8x10 - 1': 'block',

    '616 - 8x10 - 1': 'block',

    '549 - Star - 1': 'block',
    '549 - Star - 2': 'block',
    '549 - Star - 3': 'block',
    '549 - Star - 4': 'block',
    '549 - Star - 5': 'block',
    '549 - Star - 6': 'block',
    '549 - Star - 7': 'block',
    '549 - Star - 8': 'block',
    '549 - Star - 9': 'block',
    '549 - Star - 10': 'block',
    '549 - Star - 11': 'block',
    '549 - Star - 12': 'block',
    '549 - Star - 13': 'block',

    '549 - Memories - 1': 'block',
    '549 - Memories - 2': 'block',
    '549 - Memories - 3': 'block',
    '549 - Memories - 4': 'block',
    '549 - Memories - 5': 'block',
    '549 - Memories - 6': 'block',
    '549 - Memories - 7': 'block',
    '549 - Memories - 8': 'block',
    '549 - Memories - 9': 'block',
    '549 - Memories - 10': 'block',
    '549 - Memories - 11': 'block',
    '549 - Memories - 12': 'block',
    '549 - Memories - 13': 'block',

    '549 - Picture - 1': 'block',
    '549 - Picture - 2': 'block',
    '549 - Picture - 3': 'block',
    '549 - Picture - 4': 'block',
    '549 - Picture - 5': 'block',
    '549 - Picture - 6': 'block',
    '549 - Picture - 7': 'block',
    '549 - Picture - 8': 'block',
    '549 - Picture - 9': 'block',
    '549 - Picture - 10': 'block',
    '549 - Picture - 11': 'block',
    '549 - Picture - 12': 'block',
    '549 - Picture - 13': 'block',

    '549 - Basic - 1': 'block',
    '549 - Basic - 2': 'block',
    '549 - Basic - 3': 'block',
    '549 - Basic - 4': 'block',
    '549 - Basic - 5': 'block',
    '549 - Basic - 6': 'block',
    '549 - Basic - 7': 'block',
    '549 - Basic - 8': 'block',
    '549 - Basic - 9': 'block',
    '549 - Basic - 10': 'block',
    '549 - Basic - 11': 'block',
    '549 - Basic - 12': 'block',
    '549 - Basic - 13': 'block',
    '549 - Basic - 14': 'block',
    '549 - Basic - 15': 'none',
    '549 - Basic - 16': 'none',

    '549 - School - 1': 'block',
    '549 - School - 2': 'block',
    '549 - School - 3': 'block',
    '549 - School - 4': 'block',

    '550 - Star - 1': 'block',
    '550 - Star - 2': 'block',
    '550 - Star - 3': 'block',
    '550 - Star - 4': 'block',
    '550 - Star - 5': 'block',
    '550 - Star - 6': 'block',
    '550 - Star - 7': 'block',
    '550 - Star - 8': 'block',
    '550 - Star - 9': 'block',
    '550 - Star - 10': 'block',
    '550 - Star - 11': 'block',
    '550 - Star - 12': 'block',
    '550 - Star - 13': 'block',

    '550 - Memories - 1': 'block',
    '550 - Memories - 2': 'block',
    '550 - Memories - 3': 'block',
    '550 - Memories - 4': 'block',
    '550 - Memories - 5': 'block',
    '550 - Memories - 6': 'block',
    '550 - Memories - 7': 'block',
    '550 - Memories - 8': 'block',
    '550 - Memories - 9': 'block',
    '550 - Memories - 10': 'block',
    '550 - Memories - 11': 'block',
    '550 - Memories - 12': 'block',
    '550 - Memories - 13': 'block',

    '550 - Picture - 1': 'block',
    '550 - Picture - 2': 'block',
    '550 - Picture - 3': 'block',
    '550 - Picture - 4': 'block',
    '550 - Picture - 5': 'block',
    '550 - Picture - 6': 'block',
    '550 - Picture - 7': 'block',
    '550 - Picture - 8': 'block',
    '550 - Picture - 9': 'block',
    '550 - Picture - 10': 'block',
    '550 - Picture - 11': 'block',
    '550 - Picture - 12': 'block',
    '550 - Picture - 13': 'block',

    '550 - Basic - 1': 'block',
    '550 - Basic - 2': 'block',
    '550 - Basic - 3': 'block',
    '550 - Basic - 4': 'block',
    '550 - Basic - 5': 'block',
    '550 - Basic - 6': 'block',
    '550 - Basic - 7': 'block',
    '550 - Basic - 8': 'block',
    '550 - Basic - 9': 'block',
    '550 - Basic - 10': 'block',
    '550 - Basic - 11': 'block',
    '550 - Basic - 12': 'block',
    '550 - Basic - 13': 'block',
    '550 - Basic - 14': 'block',
    '550 - Basic - 15': 'none',
    '550 - Basic - 16': 'none',

    '550 - School - 1': 'block',
    '550 - School - 2': 'block',
    '550 - School - 3': 'block',
    '550 - School - 4': 'block',
    
    '550 - 8x10 - 1': 'block',

    '549 - 8x10 - 1': 'block',
  };

  //console.log(poses);
  //console.log(getRandomElement(poses));
  //const favoritePoses = favoriteIds.map((id) => poses.find((pose) => pose.id === id));
  //console.log(poses[0].imageUrl);
    
  //console.log(backgrounds[2].imageUrl);
  //console.log(option);

  function getBackgroundUrl(likestring)
  {
    for (let i = 0; i < backgrounds.length; i++) {
      if(backgrounds[i].imageUrl.includes(likestring))
        {
          return backgrounds[i].imageUrl;
        }
    }
    for (let i = 0; i < springbackgrounds.length; i++) {
      if(springbackgrounds[i].imageUrl.includes(likestring))
        {
          return springbackgrounds[i].imageUrl;
        }
    }
    return backgrounds[0].imageUrl;
  }

  function isHorizontal(aUrl)
  {
    // Check URL patterns that indicate horizontal images
    if (aUrl.includes('.jpg')) {
      return true;
    }
    if (aUrl.includes('-23.png')) {
      return true;
    }
    return false;
  }

  var blueBg = getBackgroundUrl('Senior_Blue');
  var redBg = getBackgroundUrl('Senior_Red');
  var whiteBg = getBackgroundUrl('Senior White');
  var mochaBg = getBackgroundUrl('gradmocha');
  var greenBg = getBackgroundUrl('Senior_Green');
  var archwayBg = getBackgroundUrl('Archway');
  var leavesBg = getBackgroundUrl('Leaves_Depth');
  var brownBg = getBackgroundUrl('rown');
  var grayBg = getBackgroundUrl('Gray');
  var tealBg = getBackgroundUrl('Teal');
  var concreteBg = getBackgroundUrl('oncrete');
  var springBirch = getBackgroundUrl('irch');
  var springOrchard = getBackgroundUrl('Orchard');
  var fallleaves = getBackgroundUrl('all');

  var chalkboardBg = getBackgroundUrl('halk2024');
  var classroomBg = getBackgroundUrl('lassroom');
  var flowerfieldBg = getBackgroundUrl('lowerfield');
  var springstairsBg = getBackgroundUrl('springstairs');
  var springarchBg = getBackgroundUrl('SpringArch');
  

  function getRandomIndex(array) {
    // Check if array is empty
    if (!array ) {
      return 0; // Or handle empty array case differently
    }
  
    // Get a random index within the array length
    const randomIndex = Math.floor(Math.random() * array.length);
  
    // Return the element at the random index
    return randomIndex;
  }
  //console.log(getRandomIndex(poses));

  const findTop = (img_num) => {
    if(option.name.includes('Just an 8x10'))
      {
        //1050 x 570
        if(img_num == 1)
          return '19%';
        
          return '49%';
      }
      if(option.name.includes('Picture Perfect Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '4.8%';
        if(img_num == 2)
          return '7.7%';
        if(img_num == 3)
          return '7.7%';
        if(img_num == 4)
          return '31%';
        if(img_num == 5)
          return '31%';
        if(img_num == 6)
          return '66.3%';
        if(img_num == 7)
          return '66.3%';
        if(img_num == 8)
          return '66.3%';
        if(img_num == 9)
          return '66.3%';
        if(img_num == 10)
          return '81%';
        if(img_num == 11)
          return '81%';
        if(img_num == 12)
          return '81%';
        if(img_num == 13)
          return '81%';
        if(img_num == 14)
          return '64%';
        if(img_num == 15)
          return '61.6%';

        return '7.7%';
      }
      if(option.name.includes('Gifts for Everyone Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '10.4%';
        if(img_num == 2)
          return '10.4%';
        if(img_num == 3)
          return '8.5%';
        if(img_num == 4)
          return '7.8%';
        if(img_num == 5)
          return '53.6%';
        if(img_num == 6)
          return '53.6%';
        if(img_num == 7)
          return '41.8%';
        if(img_num == 8)
          return '50.1%';
        
          return '49%';
      }
      if(option.name.includes('The Keepsake Collection'))
      {
        //1050 x 570
        if(img_num == 1)
          return '13.4%';
        if(img_num == 2)
          return '14.5%';
        if(img_num == 3)
          return '44.8%';
        if(img_num == 4)
          return '45.3%';
        if(img_num == 5)
          return '44.8%';
        if(img_num == 6)
          return '52.6%';
        if(img_num == 7)
          return '70%';
        if(img_num == 8)
          return '72%';
        if(img_num == 9)
          return '72%';
        if(img_num == 10)
          return '72%';
        if(img_num == 11)
          return '72%';
        if(img_num == 12)
          return '83.1%';
        if(img_num == 13)
          return '83.1%';
        if(img_num == 14)
          return '83.1%';
        if(img_num == 15)
          return '83.1%';
      }
      if(option.name.includes('All Digital Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '10.7%';
        if(img_num == 2)
          return '10.7%';
        if(img_num == 3)
          return '48.1%';
        if(img_num == 4)
          return '48.1%';
        
          return '49%';
      }
      if(option.name.includes('School Days Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '25.8%';
        if(img_num == 2)
          return '43%';
        if(img_num == 3)
          return '49.9%';
        
          return '49%';
      }
      if(option.name.includes('Basic Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '29.4%';
        if(img_num == 2)
          return '29.4%';
        if(img_num == 3)
          return '51.3%';
        if(img_num == 4)
          return '43.1%';
        if(img_num == 5)
          return '43.1%';
        if(img_num == 6)
          return '43.1%';
        if(img_num == 7)
          return '43.1%';
        if(img_num == 8)
          return '57.9%';
        if(img_num == 9)
          return '57.9%';
        if(img_num == 10)
          return '57.9%';
        if(img_num == 11)
          return '57.9%';
        
          return '1%';
      }

      //before Fall2026
    if(packageId == 629 && option.name.includes('Basic'))
      {
        
        const key = `629 - Basic - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 629 && option.name.includes('Star'))
      {
        
        const key = `629 - Star - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 629 && option.name.includes('Perfect'))
      {
        
        const key = `629 - Perfect - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 629 && option.name.includes('Memo'))
      {
        
        const key = `629 - Memo - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 629 && option.name.includes('Days'))
      {
        
        const key = `629 - Days - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 629 && option.name.includes('Digital'))
      {
        
        const key = `629 - Digital - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 629 && option.name.includes('Just'))
      {
        
        const key = `629 - Just - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 549 && option.name.includes('Star'))
      {
        
        const key = `549 - Star - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 549 && option.name.includes('Memories'))
      {
        
        const key = `549 - Memories - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 549 && option.name.includes('Picture'))
      {
        
        const key = `549 - Picture - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 549 && option.name.includes('Basic'))
    {
      
      const key = `549 - Basic - ${img_num}`;
      return top_percentages[key] || '0%'; // Or any default value
    }
    if(packageId == 549 && option.name.includes('School'))
      {
        
        const key = `549 - School - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 550 && option.name.includes('Star'))
      {
        
        const key = `550 - Star - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 550 && option.name.includes('Memories'))
      {
        
        const key = `550 - Memories - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 550 && option.name.includes('Picture'))
      {
        
        const key = `550 - Picture - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 550 && option.name.includes('Basic'))
    {
      
      const key = `550 - Basic - ${img_num}`;
      return top_percentages[key] || '0%'; // Or any default value
    }
    if(packageId == 550 && option.name.includes('School'))
      {
        
        const key = `550 - School - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
      if(packageId == 550 && option.name.includes('8x10'))
        {
          
          const key = `550 - 8x10 - ${img_num}`;
          return top_percentages[key] || '0%'; // Or any default value
        }
        if(packageId == 549 && option.name.includes('8x10'))
          {
            
            const key = `549 - 8x10 - ${img_num}`;
            return top_percentages[key] || '0%'; // Or any default value
          }
    if(packageId == 616 && option.name.includes('Star'))
      {
        
        const key = `616 - Star - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 616 && option.name.includes('Memories'))
      {
        
        const key = `616 - Memories - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 616 && option.name.includes('Picture'))
      {
        
        const key = `616 - Picture - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 616 && option.name.includes('Basic'))
    {
      
      const key = `616 - Basic - ${img_num}`;
      return top_percentages[key] || '0%'; // Or any default value
    }
    if(packageId == 616 && option.name.includes('School'))
      {
        
        const key = `616 - School - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 611 && option.name.includes('Star'))
      {
        
        const key = `611 - Star - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 611 && option.name.includes('Memories'))
      {
        
        const key = `611 - Memories - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 611 && option.name.includes('Picture'))
      {
        
        const key = `611 - Picture - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
    if(packageId == 611 && option.name.includes('Basic'))
    {
      
      const key = `611 - Basic - ${img_num}`;
      return top_percentages[key] || '0%'; // Or any default value
    }
    if(packageId == 611 && option.name.includes('School'))
      {
        
        const key = `611 - School - ${img_num}`;
        return top_percentages[key] || '0%'; // Or any default value
      }
      if(packageId == 611 && option.name.includes('8x10'))
        {
          
          const key = `611 - 8x10 - ${img_num}`;
          return top_percentages[key] || '0%'; // Or any default value
        }
        if(packageId == 616 && option.name.includes('8x10'))
          {
            
            const key = `616 - 8x10 - ${img_num}`;
            return top_percentages[key] || '0%'; // Or any default value
          }
      if(option.name.includes('Ultimate'))
      {
        //1050 x 570
        if(img_num == 1)
          return '16%';
        if(img_num == 2)
          return '42%';
        if(img_num == 3)
          return '42%';
        if(img_num == 4)
          return '63%';
        if(img_num == 5)
          return '9%';
        if(img_num == 6)
          return '9%';
        if(img_num == 7)
          return '55%';
        if(img_num == 8)
          return '53%';
        if(img_num == 9)
          return '53%';
        if(img_num == 10)
          return '69%';
        if(img_num == 11)
          return '69%';
        if(img_num == 12)
          return '49%';
        if(img_num == 13)
          return '49%';
        if(img_num == 14)
          return '49%';
        if(img_num == 15)
          return '49%';
      }
      else if (option.name.includes('Perfect Pack with 2 Digitals') && packageId == 610)
        {
          if(img_num == 1)
            return '13%';
          if(img_num == 2)
            return '7%';
          if(img_num == 3)
            return '7%';
          if(img_num == 4)
            return '7%';
          if(img_num == 5)
            return '7%';
          if(img_num == 6)
            return '25%';
          if(img_num == 7)
            return '25%';
          if(img_num == 8)
            return '25%';
          if(img_num == 9)
            return '25%';
          if(img_num == 10)
            return '13%';
          if(img_num == 11)
            return '49%';
          if(img_num == 12)
            return '67%';
          if(img_num == 13)
            return '49%';
          if(img_num == 14)
            return '49%';
          if(img_num == 15)
            return '49%';
        }
        else if (option.name.includes('Basic') && packageId == 610)
          {
            if(img_num == 1)
              return '29%';
            if(img_num == 2)
              return '41%';
            if(img_num == 3)
              return '35%';
            if(img_num == 4)
              return '35%';
            if(img_num == 5)
              return '35%';
            if(img_num == 6)
              return '35%';
            if(img_num == 7)
              return '56%';
            if(img_num == 8)
              return '56%';
            if(img_num == 9)
              return '56%';
            if(img_num == 10)
              return '56%';
            if(img_num == 11)
              return '49%';
            if(img_num == 12)
              return '67%';
            if(img_num == 13)
              return '49%';
            if(img_num == 14)
              return '49%';
            if(img_num == 15)
              return '49%';
          }
          else if (option.name.includes('Just a D') && packageId == 610)
            {
              if(img_num == 1)
                return '28%';
              if(img_num == 2)
                return '41%';
              if(img_num == 3)
                return '35%';
              if(img_num == 4)
                return '35%';
              if(img_num == 5)
                return '35%';
              if(img_num == 6)
                return '35%';
              if(img_num == 7)
                return '56%';
              if(img_num == 8)
                return '56%';
              if(img_num == 9)
                return '56%';
              if(img_num == 10)
                return '56%';
              if(img_num == 11)
                return '49%';
              if(img_num == 12)
                return '67%';
              if(img_num == 13)
                return '49%';
              if(img_num == 14)
                return '49%';
              if(img_num == 15)
                return '49%';
            }
          else if (option.name.includes('Just an 8') && packageId == 610)
            {
              if(img_num == 1)
                return '12%';
              if(img_num == 2)
                return '41%';
              if(img_num == 3)
                return '35%';
              if(img_num == 4)
                return '35%';
              if(img_num == 5)
                return '35%';
              if(img_num == 6)
                return '35%';
              if(img_num == 7)
                return '56%';
              if(img_num == 8)
                return '56%';
              if(img_num == 9)
                return '56%';
              if(img_num == 10)
                return '56%';
              if(img_num == 11)
                return '49%';
              if(img_num == 12)
                return '67%';
              if(img_num == 13)
                return '49%';
              if(img_num == 14)
                return '49%';
              if(img_num == 15)
                return '49%';
            }
        else if (option.name.includes('Something') && packageId == 610)
          {
            if(img_num == 1)
              return '15%';
            if(img_num == 2)
              return '7%';
            if(img_num == 3)
              return '7%';
            if(img_num == 4)
              return '7%';
            if(img_num == 5)
              return '7%';
            if(img_num == 6)
              return '25%';
            if(img_num == 7)
              return '25%';
            if(img_num == 8)
              return '25%';
            if(img_num == 9)
              return '25%';
            if(img_num == 10)
              return '18%';
            if(img_num == 11)
              return '55%';
            if(img_num == 12)
              return '55%';
            if(img_num == 13)
              return '66%';
            if(img_num == 14)
              return '66%';
            if(img_num == 15)
              return '52%';
            if(img_num == 16)
              return '52%';
          }
          else if (option.name.includes('Digital All') && packageId == 610)
            {
              if(img_num == 1)
                return '13%';
              if(img_num == 2)
                return '13%';
              if(img_num == 3)
                return '33%';
              if(img_num == 4)
                return '33%';
              if(img_num == 5)
                return '53%';
              if(img_num == 6)
                return '53%';
              if(img_num == 7)
                return '73%';
              if(img_num == 8)
                return '73%';
              if(img_num == 9)
                return '16%';
              if(img_num == 10)
                return '16%';
              if(img_num == 11)
                return '16%';
              if(img_num == 12)
                return '16%';
              if(img_num == 13)
                return '62%';
              if(img_num == 14)
                return '62%';
              if(img_num == 15)
                return '62%';
              if(img_num == 16)
                return '62%';
            }
        else if (option.name.includes('Double Double') && packageId == 610)
          {
            if(img_num == 1)
              return '11%';
            if(img_num == 2)
              return '15%';
            if(img_num == 3)
              return '19%';
            if(img_num == 4)
              return '41%';
            if(img_num == 5)
              return '7%';
            if(img_num == 6)
              return '25%';
            if(img_num == 7)
              return '25%';
            if(img_num == 8)
              return '25%';
            if(img_num == 9)
              return '25%';
            if(img_num == 10)
              return '13%';
            if(img_num == 11)
              return '49%';
            if(img_num == 12)
              return '67%';
            if(img_num == 13)
              return '49%';
            if(img_num == 14)
              return '49%';
            if(img_num == 15)
              return '49%';
          }
      else if (option.name.includes('Scholar'))
      {
        if(img_num == 1)
          return '17%';
        if(img_num == 2)
          return '32%';
        if(img_num == 3)
          return '10%';
        if(img_num == 4)
          return '10%';
        if(img_num == 5)
          return '50%';
        if(img_num == 6)
          return '54%';
        if(img_num == 7)
          return '54%';
        if(img_num == 8)
          return '66%';
        if(img_num == 9)
          return '66%';
        if(img_num == 10)
          return '49%';
        if(img_num == 11)
          return '49%';
        if(img_num == 12)
          return '49%';
        if(img_num == 13)
          return '49%';
        if(img_num == 14)
          return '49%';
        if(img_num == 15)
          return '49%';
      }
      else if (option.name.includes('Senior Special'))
        {
          if(img_num == 1)
            return '7%';
          if(img_num == 2)
            return '7%';
          if(img_num == 3)
            return '60%';
          if(img_num == 4)
            return '53%';
          if(img_num == 5)
            return '49%';
          if(img_num == 6)
            return '8%';
          if(img_num == 7)
            return '8%';
          if(img_num == 8)
            return '8%';
          if(img_num == 9)
            return '8%';
          if(img_num == 10)
            return '22%';
          if(img_num == 11)
            return '22%';
          if(img_num == 12)
            return '22%';
          if(img_num == 13)
            return '22%';
          if(img_num == 14)
            return '60%';
          if(img_num == 15)
            return '49%';
        }
        else if (option.name.includes('Standard Package'))
          {
            if(img_num == 1)
              return '27%';
            if(img_num == 2)
              return '12%';
            if(img_num == 3)
              return '12%';
            if(img_num == 4)
              return '50%';
            if(img_num == 5)
              return '50%';
            if(img_num == 6)
              return '50%';
            if(img_num == 7)
              return '50%';
            if(img_num == 8)
              return '64%';
            if(img_num == 9)
              return '64%';
            if(img_num == 10)
              return '64%';
            if(img_num == 11)
              return '64%';
            if(img_num == 12)
              return '30%';
            if(img_num == 13)
              return '30%';
            if(img_num == 14)
              return '53%';
            if(img_num == 15)
              return '53%';
          }
          else if (option.name.includes('Economy Selection'))
            {
              if(img_num == 1)
                return '35%';
              if(img_num == 2)
                return '35%';
              if(img_num == 3)
                return '40%';
              if(img_num == 4)
                return '40%';
              if(img_num == 5)
                return '40%';
              if(img_num == 6)
                return '40%';
              if(img_num == 7)
                return '56%';
              if(img_num == 8)
                return '56%';
              if(img_num == 9)
                return '56%';
              if(img_num == 10)
                return '56%';
              if(img_num == 11)
                return '24%';
              if(img_num == 12)
                return '24%';
              if(img_num == 13)
                return '48%';
              if(img_num == 14)
                return '48%';
              if(img_num == 15)
                return '67%';
            }
      
      return '0%';
    }

    const findLeft = (img_num) => {
      if(option.name.includes('Just an 8x10'))
      {
        //1050 x 570
        if(img_num == 1)
          return '35%';
        
          return '49%';
      }
      if(option.name.includes('Picture Perfect Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '5.1%';
        if(img_num == 2)
          return '37%';
        if(img_num == 3)
          return '48.6%';
        if(img_num == 4)
          return '37%';
        if(img_num == 5)
          return '48.6%';
        if(img_num == 6)
          return '5.2%';
        if(img_num == 7)
          return '12.8%';
        if(img_num == 8)
          return '20.3%';
        if(img_num == 9)
          return '27.7%';
        if(img_num == 10)
          return '5.2%';
        if(img_num == 11)
          return '12.8%';
        if(img_num == 12)
          return '20.3%';
        if(img_num == 13)
          return '27.7%';
        if(img_num == 14)
          return '37.9%';
        if(img_num == 15)
          return '68.4%';

        return '49%';
      }
      if(option.name.includes('Gifts for Everyone Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '10.3%';
        if(img_num == 2)
          return '28.5%';
        if(img_num == 3)
          return '56.5%';
        if(img_num == 4)
          return '76%';
        if(img_num == 5)
          return '10.1%';
        if(img_num == 6)
          return '28.5%';
        if(img_num == 7)
          return '55%';
        if(img_num == 8)
          return '73.4%';
        
        
          return '0%';
      }
      if(option.name.includes('The Keepsake Collection'))
      {
        //1050 x 570
        if(img_num == 1)
          return '8.2%';
        if(img_num == 2)
          return '41.0%';
        if(img_num == 3)
          return '35%';
        if(img_num == 4)
          return '46.6%';
        if(img_num == 5)
          return '61.4%';
        if(img_num == 6)
          return '78.4%';
        if(img_num == 7)
          return '4.9%';
        if(img_num == 8)
          return '33.2%';
        if(img_num == 9)
          return '38.6%';
        if(img_num == 10)
          return '44.4%';
        if(img_num == 11)
          return '50.1%';
        if(img_num == 12)
          return '33.2%';
        if(img_num == 13)
          return '38.6%';
        if(img_num == 14)
          return '44.4%';
        if(img_num == 15)
          return '50.1%';
      }
      if(option.name.includes('All Digital Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '6.1%';
        if(img_num == 2)
          return '25%';
        if(img_num == 3)
          return '6.1%';
        if(img_num == 4)
          return '29%';
        
          return '49%';
      }
      if(option.name.includes('School Days Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '7.2%';
        if(img_num == 2)
          return '41.9%';
        if(img_num == 3)
          return '67.6%';
        
        
          return '49%';
      }
      if(option.name.includes('Basic Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '14.3%';
        if(img_num == 2)
          return '36.9%';
        if(img_num == 3)
          return '36.9%';
        if(img_num == 4)
          return '54.6%';
        if(img_num == 5)
          return '62.1%';
        if(img_num == 6)
          return '69.5%';
        if(img_num == 7)
          return '76.8%';
        if(img_num == 8)
          return '54.6%';
        if(img_num == 9)
          return '62.1%';
        if(img_num == 10)
          return '69.5%';
        if(img_num == 11)
          return '76.8%';
        
          return '0%';
      }

      //before Fall2026
      if(packageId == 629 && option.name.includes('Basic'))
        {
          
          const key = `629 - Basic - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Star'))
        {
          
          const key = `629 - Star - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Perfect'))
        {
          
          const key = `629 - Perfect - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Memo'))
        {
          
          const key = `629 - Memo - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Days'))
        {
          
          const key = `629 - Days - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Digital'))
        {
          
          const key = `629 - Digital - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Just'))
        {
          
          const key = `629 - Just - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 549 && option.name.includes('Star'))
        {
          
          const key = `549 - Star - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 549 && option.name.includes('Memories'))
        {
          
          const key = `549 - Memories - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 549 && option.name.includes('Picture'))
        {
          
          const key = `549 - Picture - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 549 && option.name.includes('School'))
        {
          
          const key = `549 - School - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 549 && option.name.includes('Basic'))
        {
          
          const key = `549 - Basic - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 550 && option.name.includes('Star'))
        {
          
          const key = `550 - Star - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 550 && option.name.includes('Memories'))
        {
          
          const key = `550 - Memories - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 550 && option.name.includes('Picture'))
        {
          
          const key = `550 - Picture - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 550 && option.name.includes('School'))
        {
          
          const key = `550 - School - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
        if(packageId == 550 && option.name.includes('8x10'))
          {
            
            const key = `550 - 8x10 - ${img_num}`;
            return left_percentages[key] || '0%'; // Or any default value
          }
          if(packageId == 549 && option.name.includes('8x10'))
            {
              
              const key = `549 - 8x10 - ${img_num}`;
              return left_percentages[key] || '0%'; // Or any default value
            }
      if(packageId == 550 && option.name.includes('Basic'))
        {
          
          const key = `550 - Basic - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('Star'))
        {
          
          const key = `616 - Star - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('Memories'))
        {
          
          const key = `616 - Memories - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('Picture'))
        {
          
          const key = `616 - Picture - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('School'))
        {
          
          const key = `616 - School - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('Basic'))
        {
          
          const key = `616 - Basic - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 611 && option.name.includes('Star'))
        {
          
          const key = `611 - Star - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 611 && option.name.includes('Memories'))
        {
          
          const key = `611 - Memories - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 611 && option.name.includes('Picture'))
        {
          
          const key = `611 - Picture - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 611 && option.name.includes('School'))
        {
          
          const key = `611 - School - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
        if(packageId == 611 && option.name.includes('8x10'))
          {
            
            const key = `611 - 8x10 - ${img_num}`;
            return left_percentages[key] || '0%'; // Or any default value
          }
          if(packageId == 616 && option.name.includes('8x10'))
            {
              
              const key = `616 - 8x10 - ${img_num}`;
              return left_percentages[key] || '0%'; // Or any default value
            }
      if(packageId == 611 && option.name.includes('Basic'))
        {
          
          const key = `611 - Basic - ${img_num}`;
          return left_percentages[key] || '0%'; // Or any default value
        }
      if(option.name.includes('Ultimate'))
      {
        //1050 x 570
        if(img_num == 1)
          return '3%';
        if(img_num == 2)
          return '40%';
        if(img_num == 3)
          return '63%';
        if(img_num == 4)
          return '63%';
        if(img_num == 5)
          return '69%';
        if(img_num == 6)
          return '83%';
        if(img_num == 7)
          return '73%';
        if(img_num == 8)
          return '86%';
        if(img_num == 9)
          return '93%';
        if(img_num == 10)
          return '86%';
        if(img_num == 11)
          return '93%';
        if(img_num == 12)
          return '49%';
        if(img_num == 13)
          return '49%';
        if(img_num == 14)
          return '49%';
        if(img_num == 15)
          return '49%';
      }
      else if (option.name.includes('Scholar'))
      {
        if(img_num == 1)
          return '3%';
        if(img_num == 2)
          return '38%';
        if(img_num == 3)
          return '67%';
        if(img_num == 4)
          return '88%';
        if(img_num == 5)
          return '67%';
        if(img_num == 6)
          return '86%';
        if(img_num == 7)
          return '92%';
        if(img_num == 8)
          return '86%';
        if(img_num == 9)
          return '92%';
        if(img_num == 10)
          return '49%';
        if(img_num == 11)
          return '49%';
        if(img_num == 12)
          return '49%';
        if(img_num == 13)
          return '49%';
        if(img_num == 14)
          return '49%';
        if(img_num == 15)
          return '49%';
      }
      else if (option.name.includes('Digital A')  && packageId == 610)
        {
          if(img_num == 1)
            return '14%';
          if(img_num == 2)
            return '23%';
          if(img_num == 3)
            return '14%';
          if(img_num == 4)
            return '23%';
          if(img_num == 5)
            return '14%';
          if(img_num == 6)
            return '23%';
          if(img_num == 7)
            return '14%';
          if(img_num == 8)
            return '23%';
          if(img_num == 9)
            return '39%';
          if(img_num == 10)
            return '53%';
          if(img_num == 11)
            return '66%';
          if(img_num == 12)
            return '80%';
          if(img_num == 13)
            return '39%';
          if(img_num == 14)
            return '53%';
          if(img_num == 15)
            return '66%';
          if(img_num == 16)
            return '80%';
        }
      else if (option.name.includes('Something')  && packageId == 610)
        {
          if(img_num == 1)
            return '6%';
          if(img_num == 2)
            return '47%';
          if(img_num == 3)
            return '54%';
          if(img_num == 4)
            return '61%';
          if(img_num == 5)
            return '68%';
          if(img_num == 6)
            return '47%';
          if(img_num == 7)
            return '54%';
          if(img_num == 8)
            return '61%';
          if(img_num == 9)
            return '68%';
          if(img_num == 10)
            return '84%';
          if(img_num == 11)
            return '46%';
          if(img_num == 12)
            return '51%';
          if(img_num == 13)
            return '46%';
          if(img_num == 14)
            return '51%';
          if(img_num == 15)
            return '63%';
          if(img_num == 16)
            return '79%';
        }
      else if (option.name.includes('Double Double')  && packageId == 610)
        {
          if(img_num == 1)
            return '5%';
          if(img_num == 2)
            return '39%';
          if(img_num == 3)
            return '80%';
          if(img_num == 4)
            return '80%';
          if(img_num == 5)
            return '68%';
          if(img_num == 6)
            return '44%';
          if(img_num == 7)
            return '52%';
          if(img_num == 8)
            return '60%';
          if(img_num == 9)
            return '68%';
          if(img_num == 10)
            return '82%';
          if(img_num == 11)
            return '47%';
          if(img_num == 12)
            return '47%';
          if(img_num == 13)
            return '64%';
          if(img_num == 14)
            return '77%';
          if(img_num == 15)
            return '45%';
        }
        else if (option.name.includes('Basic')  && packageId == 610)
          {
            if(img_num == 1)
              return '10%';
            if(img_num == 2)
              return '41%';
            if(img_num == 3)
              return '59%';
            if(img_num == 4)
              return '68%';
            if(img_num == 5)
              return '77%';
            if(img_num == 6)
              return '86%';
            if(img_num == 7)
              return '59%';
            if(img_num == 8)
              return '68%';
            if(img_num == 9)
              return '77%';
            if(img_num == 10)
              return '86%';
            if(img_num == 11)
              return '47%';
            if(img_num == 12)
              return '47%';
            if(img_num == 13)
              return '64%';
            if(img_num == 14)
              return '77%';
            if(img_num == 15)
              return '45%';
          }
          else if (option.name.includes('Just an 8')  && packageId == 610)
            {
              if(img_num == 1)
                return '33%';
              if(img_num == 2)
                return '41%';
              if(img_num == 3)
                return '59%';
              if(img_num == 4)
                return '68%';
              if(img_num == 5)
                return '77%';
              if(img_num == 6)
                return '86%';
              if(img_num == 7)
                return '59%';
              if(img_num == 8)
                return '68%';
              if(img_num == 9)
                return '77%';
              if(img_num == 10)
                return '86%';
              if(img_num == 11)
                return '47%';
              if(img_num == 12)
                return '47%';
              if(img_num == 13)
                return '64%';
              if(img_num == 14)
                return '77%';
              if(img_num == 15)
                return '45%';
            }
            else if (option.name.includes('Just a D')  && packageId == 610)
              {
                if(img_num == 1)
                  return '12%';
                if(img_num == 2)
                  return '41%';
                if(img_num == 3)
                  return '59%';
                if(img_num == 4)
                  return '68%';
                if(img_num == 5)
                  return '77%';
                if(img_num == 6)
                  return '86%';
                if(img_num == 7)
                  return '59%';
                if(img_num == 8)
                  return '68%';
                if(img_num == 9)
                  return '77%';
                if(img_num == 10)
                  return '86%';
                if(img_num == 11)
                  return '47%';
                if(img_num == 12)
                  return '47%';
                if(img_num == 13)
                  return '64%';
                if(img_num == 14)
                  return '77%';
                if(img_num == 15)
                  return '45%';
              }
      else if (option.name.includes('Perfect Pack') && packageId == 610)
        {
          if(img_num == 1)
            return '6%';
          if(img_num == 2)
            return '44%';
          if(img_num == 3)
            return '52%';
          if(img_num == 4)
            return '60%';
          if(img_num == 5)
            return '68%';
          if(img_num == 6)
            return '44%';
          if(img_num == 7)
            return '52%';
          if(img_num == 8)
            return '60%';
          if(img_num == 9)
            return '68%';
          if(img_num == 10)
            return '82%';
          if(img_num == 11)
            return '47%';
          if(img_num == 12)
            return '47%';
          if(img_num == 13)
            return '64%';
          if(img_num == 14)
            return '77%';
          if(img_num == 15)
            return '45%';
        }
      else if (option.name.includes('Senior Special'))
        {
          if(img_num == 1)
            return '4%';
          if(img_num == 2)
            return '31%';
          if(img_num == 3)
            return '14%';
          if(img_num == 4)
            return '81%';
          if(img_num == 5)
            return '63%';
          if(img_num == 6)
            return '60%';
          if(img_num == 7)
            return '67%';
          if(img_num == 8)
            return '74%';
          if(img_num == 9)
            return '81%';
          if(img_num == 10)
            return '60%';
          if(img_num == 11)
            return '67%';
          if(img_num == 12)
            return '74%';
          if(img_num == 13)
            return '81%';
          if(img_num == 14)
            return '26%';
          if(img_num == 15)
            return '49%';
        }
        else if (option.name.includes('Standard Package'))
          {
            if(img_num == 1)
              return '10%';
            if(img_num == 2)
              return '40%';
            if(img_num == 3)
              return '55%';
            if(img_num == 4)
              return '42%';
            if(img_num == 5)
              return '49%';
            if(img_num == 6)
              return '55%';
            if(img_num == 7)
              return '62%';
            if(img_num == 8)
              return '42%';
            if(img_num == 9)
              return '49%';
            if(img_num == 10)
              return '55%';
            if(img_num == 11)
              return '62%';
            if(img_num == 12)
              return '72%';
            if(img_num == 13)
              return '84%';
            if(img_num == 14)
              return '72%';
            if(img_num == 15)
              return '84%';
          }
          else if (option.name.includes('Economy Selection'))
            {
              if(img_num == 1)
                return '4%';
              if(img_num == 2)
                return '21%';
              if(img_num == 3)
                return '42%';
              if(img_num == 4)
                return '49%';
              if(img_num == 5)
                return '56%';
              if(img_num == 6)
                return '64%';
              if(img_num == 7)
                return '42%';
              if(img_num == 8)
                return '49%';
              if(img_num == 9)
                return '56%';
              if(img_num == 10)
                return '64%';
              if(img_num == 11)
                return '75%';
              if(img_num == 12)
                return '86%';
              if(img_num == 13)
                return '75%';
              if(img_num == 14)
                return '86%';
              if(img_num == 15)
                return '67%';
            }

      return '0%';
    }

    const findWidth = (img_num) => {
      if(option.name.includes('Just an 8x10'))
      {
        //1050 x 570
        if(img_num == 1)
          return '30%';
        
          return '49%';
      }
      if(option.name.includes('Picture Perfect Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '29.2%';
        if(img_num == 2)
          return '11.5%';
        if(img_num == 3)
          return '11.5%';
        if(img_num == 4)
          return '11.5%';
        if(img_num == 5)
          return '11.5%';
        if(img_num == 6)
          return '7%';
        if(img_num == 7)
          return '7%';
        if(img_num == 8)
          return '7%';
        if(img_num == 9)
          return '7%';
        if(img_num == 10)
          return '7%';
        if(img_num == 11)
          return '7%';
        if(img_num == 12)
          return '7%';
        if(img_num == 13)
          return '7%';
        if(img_num == 14)
          return '24.1%';
        if(img_num == 15)
          return '12.1%';
      }
      if(option.name.includes('Gifts for Everyone Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '18%';
        if(img_num == 2)
          return '18%';
        if(img_num == 3)
          return '13%';
        if(img_num == 4)
          return '13%';
        if(img_num == 5)
          return '18%';
        if(img_num == 6)
          return '18%';
        if(img_num == 7)
          return '16.5%';
        if(img_num == 8)
          return '16.5%';
        
          return '0%';
      }
      if(option.name.includes('The Keepsake Collection'))
      {
        //1050 x 570
        if(img_num == 1)
          return '22.9%';
        if(img_num == 2)
          return '13%';
        if(img_num == 3)
          return '9.2%';
        if(img_num == 4)
          return '9.2%';
        if(img_num == 5)
          return '15.5%';
        if(img_num == 6)
          return '15.5%';
        if(img_num == 7)
          return '8.1%';
        if(img_num == 8)
          return '5.2%';
        if(img_num == 9)
          return '5.2%';
        if(img_num == 10)
          return '5.2%';
        if(img_num == 11)
          return '5.2%';
        if(img_num == 12)
          return '5.2%';
        if(img_num == 13)
          return '5.2%';
        if(img_num == 14)
          return '5.2%';
        if(img_num == 15)
          return '5.2%';
      }
      if(option.name.includes('All Digital Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '17%';
        if(img_num == 2)
          return '17%';
        if(img_num == 3)
          return '21%';
        if(img_num == 4)
          return '13.2%';
        
          return '49%';
      }
      if(option.name.includes('School Days Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '29.1%';
        if(img_num == 2)
          return '20%';
        if(img_num == 3)
          return '12.4%';
        
          return '49%';
      }
      if(option.name.includes('Basic Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return '21.7%';
        if(img_num == 2)
          return '10.7%';
        if(img_num == 3)
          return '10.7%';
        if(img_num == 4)
          return '7.1%';
        if(img_num == 5)
          return '7.1%';
        if(img_num == 6)
          return '7.1%';
        if(img_num == 7)
          return '7.1%';
        if(img_num == 8)
          return '7.1%';
        if(img_num == 9)
          return '7.1%';
        if(img_num == 10)
          return '7.1%';
        if(img_num == 11)
          return '7.1%';
        
          return '0%';
      }

      //before Fall2026
      if(packageId == 629 && option.name.includes('Basic'))
        {
          
          const key = `629 - Basic - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Star'))
        {
          
          const key = `629 - Star - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Perfect'))
        {
          
          const key = `629 - Perfect - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Memo'))
        {
          
          const key = `629 - Memo - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Days'))
        {
          
          const key = `629 - Days - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Digital'))
        {
          
          const key = `629 - Digital - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Just'))
        {
          
          const key = `629 - Just - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 549 && option.name.includes('Star'))
        {
          
          const key = `549 - Star - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 549 && option.name.includes('Memories'))
        {
          
          const key = `549 - Memories - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 549 && option.name.includes('Picture'))
        {
          
          const key = `549 - Picture - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 549 && option.name.includes('School'))
        {
          
          const key = `549 - School - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 549 && option.name.includes('Basic'))
        {
          
          const key = `549 - Basic - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 550 && option.name.includes('Star'))
        {
          
          const key = `550 - Star - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 550 && option.name.includes('Memories'))
        {
          
          const key = `550 - Memories - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 550 && option.name.includes('Picture'))
        {
          
          const key = `550 - Picture - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 550 && option.name.includes('School'))
        {
          
          const key = `550 - School - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
        if(packageId == 550 && option.name.includes('8x10'))
          {
            
            const key = `550 - 8x10 - ${img_num}`;
            return width_percentages[key] || '0%'; // Or any default value
          }
          if(packageId == 549 && option.name.includes('8x10'))
            {
              
              const key = `549 - 8x10 - ${img_num}`;
              return width_percentages[key] || '0%'; // Or any default value
            }
      if(packageId == 550 && option.name.includes('Basic'))
        {
          
          const key = `550 - Basic - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('Star'))
        {
          
          const key = `616 - Star - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('Memories'))
        {
          
          const key = `616 - Memories - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('Picture'))
        {
          
          const key = `616 - Picture - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('School'))
        {
          
          const key = `616 - School - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('Basic'))
        {
          
          const key = `616 - Basic - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 611 && option.name.includes('Star'))
        {
          
          const key = `611 - Star - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 611 && option.name.includes('Memories'))
        {
          
          const key = `611 - Memories - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 611 && option.name.includes('Picture'))
        {
          
          const key = `611 - Picture - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 611 && option.name.includes('School'))
        {
          
          const key = `611 - School - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
        if(packageId == 611 && option.name.includes('8x10'))
          {
            
            const key = `611 - 8x10 - ${img_num}`;
            return width_percentages[key] || '0%'; // Or any default value
          }
          if(packageId == 616 && option.name.includes('8x10'))
            {
              
              const key = `616 - 8x10 - ${img_num}`;
              return width_percentages[key] || '0%'; // Or any default value
            }
      if(packageId == 611 && option.name.includes('Basic'))
        {
          
          const key = `611 - Basic - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(option.name.includes('Ultimate'))
      {
        if(img_num == 1)
          return '32%';
        if(img_num == 2)
          return '20%';
        if(img_num == 3)
          return '8%';
        if(img_num == 4)
          return '8%';
        if(img_num == 5)
          return '14%';
        if(img_num == 6)
          return '14%';
        if(img_num == 7)
          return '10%';
        if(img_num == 8)
          return '6%';
        if(img_num == 9)
          return '6%';
        if(img_num == 10)
          return '6%';
        if(img_num == 11)
          return '6%';
        if(img_num == 12)
          return '49%';
        if(img_num == 13)
          return '49%';
        if(img_num == 14)
          return '49%';
        if(img_num == 15)
          return '49%';
      }
      else if (option.name.includes('Scholar'))
      {
        if(img_num == 1)
          return '32%';
        if(img_num == 2)
          return '26%';
        if(img_num == 3)
          return '12%';
        if(img_num == 4)
          return '9%';
        if(img_num == 5)
          return '12%';
        if(img_num == 6)
          return '6%';
        if(img_num == 7)
          return '6%';
        if(img_num == 8)
          return '6%';
        if(img_num == 9)
          return '6%';
        if(img_num == 10)
          return '49%';
        if(img_num == 11)
          return '49%';
        if(img_num == 12)
          return '49%';
        if(img_num == 13)
          return '49%';
        if(img_num == 14)
          return '49%';
        if(img_num == 15)
          return '49%';
      }
      else if (option.name.includes('Double Double') && packageId == 610)
        {
          if(img_num == 1)
            return '32%';
          if(img_num == 2)
            return '32%';
          if(img_num == 3)
            return '9%';
          if(img_num == 4)
            return '9%';
          if(img_num == 5)
            return '8%';
          if(img_num == 6)
            return '8%';
          if(img_num == 7)
            return '8%';
          if(img_num == 8)
            return '8%';
          if(img_num == 9)
            return '8%';
          if(img_num == 10)
            return '13%';
          if(img_num == 11)
            return '7%';
          if(img_num == 12)
            return '7%';
          if(img_num == 13)
            return '15%';
          if(img_num == 14)
            return '15%';
          if(img_num == 15)
            return '49%';
        }
        else if (option.name.includes('Digital A') && packageId == 610)
          {
            if(img_num == 1)
              return '8%';
            if(img_num == 2)
              return '8%';
            if(img_num == 3)
              return '8%';
            if(img_num == 4)
              return '8%';
            if(img_num == 5)
              return '8%';
            if(img_num == 6)
              return '8%';
            if(img_num == 7)
              return '8%';
            if(img_num == 8)
              return '8%';
            if(img_num == 9)
              return '12%';
            if(img_num == 10)
              return '12%';
            if(img_num == 11)
              return '12%';
            if(img_num == 12)
              return '12%';
            if(img_num == 13)
              return '12%';
            if(img_num == 14)
              return '12%';
            if(img_num == 15)
              return '12%';
            if(img_num == 16)
              return '12%';
          }
        else if (option.name.includes('Something') && packageId == 610)
          {
            if(img_num == 1)
              return '34%';
            if(img_num == 2)
              return '8%';
            if(img_num == 3)
              return '8%';
            if(img_num == 4)
              return '8%';
            if(img_num == 5)
              return '8%';
            if(img_num == 6)
              return '8%';
            if(img_num == 7)
              return '8%';
            if(img_num == 8)
              return '8%';
            if(img_num == 9)
              return '8%';
            if(img_num == 10)
              return '12%';
            if(img_num == 11)
              return '4%';
            if(img_num == 12)
              return '4%';
            if(img_num == 13)
              return '4%';
            if(img_num == 14)
              return '4%';
            if(img_num == 15)
              return '15%';
            if(img_num == 16)
              return '15%';
          }
      else if (option.name.includes('Perfect Pack') && packageId == 610)
        {
          if(img_num == 1)
            return '35%';
          if(img_num == 2)
            return '8%';
          if(img_num == 3)
            return '8%';
          if(img_num == 4)
            return '8%';
          if(img_num == 5)
            return '8%';
          if(img_num == 6)
            return '8%';
          if(img_num == 7)
            return '8%';
          if(img_num == 8)
            return '8%';
          if(img_num == 9)
            return '8%';
          if(img_num == 10)
            return '13%';
          if(img_num == 11)
            return '7%';
          if(img_num == 12)
            return '7%';
          if(img_num == 13)
            return '15%';
          if(img_num == 14)
            return '15%';
          if(img_num == 15)
            return '49%';
        }
        else if (option.name.includes('Basic') && packageId == 610)
          {
            if(img_num == 1)
              return '23%';
            if(img_num == 2)
              return '13%';
            if(img_num == 3)
              return '8%';
            if(img_num == 4)
              return '8%';
            if(img_num == 5)
              return '8%';
            if(img_num == 6)
              return '8%';
            if(img_num == 7)
              return '8%';
            if(img_num == 8)
              return '8%';
            if(img_num == 9)
              return '8%';
            if(img_num == 10)
              return '8%';
            if(img_num == 11)
              return '7%';
            if(img_num == 12)
              return '7%';
            if(img_num == 13)
              return '15%';
            if(img_num == 14)
              return '15%';
            if(img_num == 15)
              return '49%';
          }
          else if (option.name.includes('Just an 8') && packageId == 610)
            {
              if(img_num == 1)
                return '35%';
              if(img_num == 2)
                return '13%';
              if(img_num == 3)
                return '8%';
              if(img_num == 4)
                return '8%';
              if(img_num == 5)
                return '8%';
              if(img_num == 6)
                return '8%';
              if(img_num == 7)
                return '8%';
              if(img_num == 8)
                return '8%';
              if(img_num == 9)
                return '8%';
              if(img_num == 10)
                return '8%';
              if(img_num == 11)
                return '7%';
              if(img_num == 12)
                return '7%';
              if(img_num == 13)
                return '15%';
              if(img_num == 14)
                return '15%';
              if(img_num == 15)
                return '49%';
            }
            else if (option.name.includes('Just a D') && packageId == 610)
              {
                if(img_num == 1)
                  return '20%';
                if(img_num == 2)
                  return '13%';
                if(img_num == 3)
                  return '8%';
                if(img_num == 4)
                  return '8%';
                if(img_num == 5)
                  return '8%';
                if(img_num == 6)
                  return '8%';
                if(img_num == 7)
                  return '8%';
                if(img_num == 8)
                  return '8%';
                if(img_num == 9)
                  return '8%';
                if(img_num == 10)
                  return '8%';
                if(img_num == 11)
                  return '7%';
                if(img_num == 12)
                  return '7%';
                if(img_num == 13)
                  return '15%';
                if(img_num == 14)
                  return '15%';
                if(img_num == 15)
                  return '49%';
              }
      else if (option.name.includes('Senior Special'))
        {
          if(img_num == 1)
            return '25%';
          if(img_num == 2)
            return '25%';
          if(img_num == 3)
            return '13%';
          if(img_num == 4)
            return '15%';
          if(img_num == 5)
            return '12%';
          if(img_num == 6)
            return '7%';
          if(img_num == 7)
            return '7%';
          if(img_num == 8)
            return '7%';
          if(img_num == 9)
            return '7%';
          if(img_num == 10)
            return '7%';
          if(img_num == 11)
            return '7%';
          if(img_num == 12)
            return '7%';
          if(img_num == 13)
            return '7%';
          if(img_num == 14)
            return '13%';
          if(img_num == 15)
            return '49%';
        }
        else if (option.name.includes('Standard Package'))
          {
            if(img_num == 1)
              return '24%';
            if(img_num == 2)
              return '16%';
            if(img_num == 3)
              return '16%';
            if(img_num == 4)
              return '7.5%';
            if(img_num == 5)
              return '7.5%';
            if(img_num == 6)
              return '7.5%';
            if(img_num == 7)
              return '7.5%';
            if(img_num == 8)
              return '7.5%';
            if(img_num == 9)
              return '7.5%';
            if(img_num == 10)
              return '7.5%';
            if(img_num == 11)
              return '7.5%';
            if(img_num == 12)
              return '12%';
            if(img_num == 13)
              return '12%';
            if(img_num == 14)
              return '12%';
            if(img_num == 15)
              return '12%';
          }
          else if (option.name.includes('Economy Selection'))
            {
              if(img_num == 1)
                return '18%';
              if(img_num == 2)
                return '18%';
              if(img_num == 3)
                return '8%';
              if(img_num == 4)
                return '8%';
              if(img_num == 5)
                return '8%';
              if(img_num == 6)
                return '8%';
              if(img_num == 7)
                return '8%';
              if(img_num == 8)
                return '8%';
              if(img_num == 9)
                return '8%';
              if(img_num == 10)
                return '8%';
              if(img_num == 11)
                return '12%';
              if(img_num == 12)
                return '12%';
              if(img_num == 13)
                return '12%';
              if(img_num == 14)
                return '12%';
              if(img_num == 15)
                return '12%';
            }
      
      return '0%';
    }

    const findDisplay = (img_num) => {
      if(option.name.includes('Just an 8x10'))
      {
        //1050 x 570
        if(img_num == 1)
          return 'block';
        
          return 'none';
      }
      if(option.name.includes('Picture Perfect Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return 'block';
        if(img_num == 2)
          return 'block';
        if(img_num == 3)
          return 'block';
        if(img_num == 4)
          return 'block';
        if(img_num == 5)
          return 'block';
        if(img_num == 6)
          return 'block';
        if(img_num == 7)
          return 'block';
        if(img_num == 8)
          return 'block';
        if(img_num == 9)
          return 'block';
        if(img_num == 10)
          return 'block';
        if(img_num == 11)
          return 'block';
        if(img_num == 12)
          return 'block';
        if(img_num == 13)
          return 'block';
        if(img_num == 14)
          return 'block';
        if(img_num == 15)
          return 'block';
      }
      if(option.name.includes('Gifts for Everyone Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return 'block';
        if(img_num == 2)
          return 'block';
        if(img_num == 3)
          return 'block';
        if(img_num == 4)
          return 'block';
        if(img_num == 5)
          return 'block';
        if(img_num == 6)
          return 'block';
        if(img_num == 7)
          return 'block';
        if(img_num == 8)
          return 'block';
        
          return 'none';
      }
      if(option.name.includes('The Keepsake Collection'))
      {
        //1050 x 570
        if(img_num == 1)
          return 'block';
        if(img_num == 2)
          return 'block';
        if(img_num == 3)
          return 'block';
        if(img_num == 4)
          return 'block';
        if(img_num == 5)
          return 'block';
        if(img_num == 6)
          return 'block';
        if(img_num == 7)
          return 'block';
        if(img_num == 8)
          return 'block';
        if(img_num == 9)
          return 'block';
        if(img_num == 10)
          return 'block';
        if(img_num == 11)
          return 'block';
        if(img_num == 12)
          return 'block';
        if(img_num == 13)
          return 'block';
        if(img_num == 14)
          return 'block';
        if(img_num == 15)
          return 'block';
      }
      if(option.name.includes('All Digital Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return 'block';
        if(img_num == 2)
          return 'block';
        if(img_num == 3)
          return 'block';
        if(img_num == 4)
          return 'block';
        
          return 'none';
      }
      if(option.name.includes('School Days Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return 'block';
        if(img_num == 2)
          return 'block';
        if(img_num == 3)
          return 'block';
        
          return 'none';
      }
      if(option.name.includes('Basic Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return 'block';
        if(img_num == 2)
          return 'block';
        if(img_num == 3)
          return 'block';
        if(img_num == 4)
          return 'block';
        if(img_num == 5)
          return 'block';
        if(img_num == 6)
          return 'block';
        if(img_num == 7)
          return 'block';
        if(img_num == 8)
          return 'block';
        if(img_num == 9)
          return 'block';
        if(img_num == 10)
          return 'block';
        if(img_num == 11)
          return 'block';
        
          return 'none';
      }

      //before Fall2026
      if(packageId == 629 && option.name.includes('Basic'))
        {
          
          const key = `629 - Basic - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Star'))
        {
          
          const key = `629 - Star - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Perfect'))
        {
          
          const key = `629 - Perfect - ${img_num}`;
          return width_percentages[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Memo'))
        {
          
          const key = `629 - Memo - ${img_num}`;
          return display_types[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Days'))
        {
          
          const key = `629 - Days - ${img_num}`;
          return display_types[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Digital'))
        {
          
          const key = `629 - Digital - ${img_num}`;
          return display_types[key] || '0%'; // Or any default value
        }
      if(packageId == 629 && option.name.includes('Just'))
        {
          
          const key = `629 - Just - ${img_num}`;
          return display_types[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('Star'))
        {
          
          const key = `616 - Star - ${img_num}`;
          return display_types[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('Memories'))
        {
          
          const key = `616 - Memories - ${img_num}`;
          return display_types[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('Picture'))
        {
          
          const key = `616 - Picture - ${img_num}`;
          return display_types[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('School'))
        {
          
          const key = `616 - School - ${img_num}`;
          return display_types[key] || '0%'; // Or any default value
        }
      if(packageId == 616 && option.name.includes('Basic'))
        {
          
          const key = `616 - Basic - ${img_num}`;
          return display_types[key] || 'none'; // Or any default value
        }
      if(packageId == 611 && option.name.includes('Star'))
        {
          
          const key = `611 - Star - ${img_num}`;
          return display_types[key] || '0%'; // Or any default value
        }
      if(packageId == 611 && option.name.includes('Memories'))
        {
          
          const key = `611 - Memories - ${img_num}`;
          return display_types[key] || '0%'; // Or any default value
        }
      if(packageId == 611 && option.name.includes('Picture'))
        {
          
          const key = `611 - Picture - ${img_num}`;
          return display_types[key] || '0%'; // Or any default value
        }
      if(packageId == 611 && option.name.includes('School'))
        {
          
          const key = `611 - School - ${img_num}`;
          return display_types[key] || '0%'; // Or any default value
        }
        if(packageId == 611 && option.name.includes('8x10'))
          {
            
            const key = `611 - 8x10 - ${img_num}`;
            return display_types[key] || '0%'; // Or any default value
          }
          if(packageId == 616 && option.name.includes('8x10'))
            {
              
              const key = `616 - 8x10 - ${img_num}`;
              return display_types[key] || '0%'; // Or any default value
            }
      if(packageId == 611 && option.name.includes('Basic'))
        {
          
          const key = `611 - Basic - ${img_num}`;
          return display_types[key] || 'none'; // Or any default value
        }
        if(packageId == 549 && option.name.includes('Star'))
          {
            
            const key = `549 - Star - ${img_num}`;
            return display_types[key] || '0%'; // Or any default value
          }
        if(packageId == 549 && option.name.includes('Memories'))
          {
            
            const key = `549 - Memories - ${img_num}`;
            return display_types[key] || '0%'; // Or any default value
          }
        if(packageId == 549 && option.name.includes('Picture'))
          {
            
            const key = `549 - Picture - ${img_num}`;
            return display_types[key] || '0%'; // Or any default value
          }
        if(packageId == 549 && option.name.includes('School'))
          {
            
            const key = `549 - School - ${img_num}`;
            return display_types[key] || '0%'; // Or any default value
          }
        if(packageId == 549 && option.name.includes('Basic'))
          {
            
            const key = `549 - Basic - ${img_num}`;
            return display_types[key] || 'none'; // Or any default value
          }
        if(packageId == 550 && option.name.includes('Star'))
          {
            
            const key = `550 - Star - ${img_num}`;
            return display_types[key] || '0%'; // Or any default value
          }
        if(packageId == 550 && option.name.includes('Memories'))
          {
            
            const key = `550 - Memories - ${img_num}`;
            return display_types[key] || '0%'; // Or any default value
          }
        if(packageId == 550 && option.name.includes('Picture'))
          {
            
            const key = `550 - Picture - ${img_num}`;
            return display_types[key] || '0%'; // Or any default value
          }
        if(packageId == 550 && option.name.includes('School'))
          {
            
            const key = `550 - School - ${img_num}`;
            return display_types[key] || '0%'; // Or any default value
          }
          if(packageId == 550 && option.name.includes('8x10'))
            {
              
              const key = `550 - 8x10 - ${img_num}`;
              return display_types[key] || '0%'; // Or any default value
            }
            if(packageId == 549 && option.name.includes('8x10'))
              {
                
                const key = `549 - 8x10 - ${img_num}`;
                return display_types[key] || '0%'; // Or any default value
              }
        if(packageId == 550 && option.name.includes('Basic'))
          {
            
            const key = `550 - Basic - ${img_num}`;
            return display_types[key] || 'none'; // Or any default value
          }
      if(option.name.includes('Ultimate'))
      {
        if(img_num == 1)
          return 'block';
        if(img_num == 2)
          return 'block';
        if(img_num == 3)
          return 'block';
        if(img_num == 4)
          return 'block';
        if(img_num == 5)
          return 'block';
        if(img_num == 6)
          return 'block';
        if(img_num == 7)
          return 'block';
        if(img_num == 8)
          return 'block';
        if(img_num == 9)
          return 'block';
        if(img_num == 10)
          return 'block';
        if(img_num == 11)
          return 'block';
        if(img_num == 12)
          return 'none';
        if(img_num == 13)
          return 'none';
        if(img_num == 14)
          return 'none';
        if(img_num == 15)
          return 'none';
        if(img_num == 16)
          return 'none';
      }
      else if (option.name.includes('Scholar'))
      {
        if(img_num == 1)
          return 'block';
        if(img_num == 2)
          return 'block';
        if(img_num == 3)
          return 'block';
        if(img_num == 4)
          return 'block';
        if(img_num == 5)
          return 'block';
        if(img_num == 6)
          return 'block';
        if(img_num == 7)
          return 'block';
        if(img_num == 8)
          return 'block';
        if(img_num == 9)
          return 'block';
        if(img_num == 10)
          return 'none';
        if(img_num == 11)
          return 'none';
        if(img_num == 12)
          return 'none';
        if(img_num == 13)
          return 'none';
        if(img_num == 14)
          return 'none';
        if(img_num == 15)
          return 'none';
        if(img_num == 16)
          return 'none';
      }
      else if (option.name.includes('Perfect Pack') && packageId == 610)
        {
          if(img_num == 1)
            return 'block';
          if(img_num == 2)
            return 'block';
          if(img_num == 3)
            return 'block';
          if(img_num == 4)
            return 'block';
          if(img_num == 5)
            return 'block';
          if(img_num == 6)
            return 'block';
          if(img_num == 7)
            return 'block';
          if(img_num == 8)
            return 'block';
          if(img_num == 9)
            return 'block';
          if(img_num == 10)
            return 'block';
          if(img_num == 11)
            return 'block';
          if(img_num == 12)
            return 'block';
          if(img_num == 13)
            return 'block';
          if(img_num == 14)
            return 'block';
          if(img_num == 15)
            return 'none';
          if(img_num == 16)
            return 'none';
        }
        else if (option.name.includes('Basic') && packageId == 610)
          {
            if(img_num == 1)
              return 'block';
            if(img_num == 2)
              return 'block';
            if(img_num == 3)
              return 'block';
            if(img_num == 4)
              return 'block';
            if(img_num == 5)
              return 'block';
            if(img_num == 6)
              return 'block';
            if(img_num == 7)
              return 'block';
            if(img_num == 8)
              return 'block';
            if(img_num == 9)
              return 'block';
            if(img_num == 10)
              return 'block';
            if(img_num == 11)
              return 'none';
            if(img_num == 12)
              return 'none';
            if(img_num == 13)
              return 'none';
            if(img_num == 14)
              return 'none';
            if(img_num == 15)
              return 'none';
            if(img_num == 16)
              return 'none';
          }
          else if (option.name.includes('Just an 8') && packageId == 610)
            {
              if(img_num == 1)
                return 'block';
              if(img_num == 2)
                return 'none';
              if(img_num == 3)
                return 'none';
              if(img_num == 4)
                return 'none';
              if(img_num == 5)
                return 'none';
              if(img_num == 6)
                return 'none';
              if(img_num == 7)
                return 'none';
              if(img_num == 8)
                return 'none';
              if(img_num == 9)
                return 'none';
              if(img_num == 10)
                return 'none';
              if(img_num == 11)
                return 'none';
              if(img_num == 12)
                return 'none';
              if(img_num == 13)
                return 'none';
              if(img_num == 14)
                return 'none';
              if(img_num == 15)
                return 'none';
              if(img_num == 16)
                return 'none';
            }
            else if (option.name.includes('Just a D') && packageId == 610)
              {
                if(img_num == 1)
                  return 'block';
                if(img_num == 2)
                  return 'none';
                if(img_num == 3)
                  return 'none';
                if(img_num == 4)
                  return 'none';
                if(img_num == 5)
                  return 'none';
                if(img_num == 6)
                  return 'none';
                if(img_num == 7)
                  return 'none';
                if(img_num == 8)
                  return 'none';
                if(img_num == 9)
                  return 'none';
                if(img_num == 10)
                  return 'none';
                if(img_num == 11)
                  return 'none';
                if(img_num == 12)
                  return 'none';
                if(img_num == 13)
                  return 'none';
                if(img_num == 14)
                  return 'none';
                if(img_num == 15)
                  return 'none';
                if(img_num == 16)
                  return 'none';
              }
              else if (option.name.includes('Digital A') && packageId == 610)
                {
                  if(img_num == 1)
                    return 'block';
                  if(img_num == 2)
                    return 'block';
                  if(img_num == 3)
                    return 'block';
                  if(img_num == 4)
                    return 'block';
                  if(img_num == 5)
                    return 'block';
                  if(img_num == 6)
                    return 'block';
                  if(img_num == 7)
                    return 'block';
                  if(img_num == 8)
                    return 'block';
                  if(img_num == 9)
                    return 'block';
                  if(img_num == 10)
                    return 'block';
                  if(img_num == 11)
                    return 'block';
                  if(img_num == 12)
                    return 'block';
                  if(img_num == 13)
                    return 'block';
                  if(img_num == 14)
                    return 'block';
                  if(img_num == 15)
                    return 'block';
                  if(img_num == 16)
                    return 'block';
                }
        else if (option.name.includes('Something') && packageId == 610)
          {
            if(img_num == 1)
              return 'block';
            if(img_num == 2)
              return 'block';
            if(img_num == 3)
              return 'block';
            if(img_num == 4)
              return 'block';
            if(img_num == 5)
              return 'block';
            if(img_num == 6)
              return 'block';
            if(img_num == 7)
              return 'block';
            if(img_num == 8)
              return 'block';
            if(img_num == 9)
              return 'block';
            if(img_num == 10)
              return 'block';
            if(img_num == 11)
              return 'block';
            if(img_num == 12)
              return 'block';
            if(img_num == 13)
              return 'block';
            if(img_num == 14)
              return 'block';
            if(img_num == 15)
              return 'block';
            if(img_num == 16)
              return 'block';
          }
      else if (option.name.includes('Double Double') && packageId == 610)
        {
          if(img_num == 1)
            return 'block';
          if(img_num == 2)
            return 'block';
          if(img_num == 3)
            return 'block';
          if(img_num == 4)
            return 'block';
          if(img_num == 5)
            return 'none';
          if(img_num == 6)
            return 'none';
          if(img_num == 7)
            return 'none';
          if(img_num == 8)
            return 'none';
          if(img_num == 9)
            return 'none';
          if(img_num == 10)
            return 'none';
          if(img_num == 11)
            return 'none';
          if(img_num == 12)
            return 'none';
          if(img_num == 13)
            return 'none';
          if(img_num == 14)
            return 'none';
          if(img_num == 15)
            return 'none';
          if(img_num == 16)
            return 'none';
        }
      else if (option.name.includes('Senior Special'))
        {
          if(img_num == 1)
            return 'block';
          if(img_num == 2)
            return 'block';
          if(img_num == 3)
            return 'block';
          if(img_num == 4)
            return 'block';
          if(img_num == 5)
            return 'block';
          if(img_num == 6)
            return 'block';
          if(img_num == 7)
            return 'block';
          if(img_num == 8)
            return 'block';
          if(img_num == 9)
            return 'block';
          if(img_num == 10)
            return 'block';
          if(img_num == 11)
            return 'block';
          if(img_num == 12)
            return 'block';
          if(img_num == 13)
            return 'block';
          if(img_num == 14)
            return 'block';
          if(img_num == 15)
            return 'none';
          if(img_num == 16)
            return 'none';
        }
        else if (option.name.includes('Standard Package'))
          {
            if(img_num == 1)
              return 'block';
            if(img_num == 2)
              return 'block';
            if(img_num == 3)
              return 'block';
            if(img_num == 4)
              return 'block';
            if(img_num == 5)
              return 'block';
            if(img_num == 6)
              return 'block';
            if(img_num == 7)
              return 'block';
            if(img_num == 8)
              return 'block';
            if(img_num == 9)
              return 'block';
            if(img_num == 10)
              return 'block';
            if(img_num == 11)
              return 'block';
            if(img_num == 12)
              return 'block';
            if(img_num == 13)
              return 'block';
            if(img_num == 14)
              return 'block';
            if(img_num == 15)
              return 'block';
            if(img_num == 16)
              return 'none';
          }
          else if (option.name.includes('Economy Selection'))
            {
              if(img_num == 1)
                return 'block';
              if(img_num == 2)
                return 'block';
              if(img_num == 3)
                return 'block';
              if(img_num == 4)
                return 'block';
              if(img_num == 5)
                return 'block';
              if(img_num == 6)
                return 'block';
              if(img_num == 7)
                return 'block';
              if(img_num == 8)
                return 'block';
              if(img_num == 9)
                return 'block';
              if(img_num == 10)
                return 'block';
              if(img_num == 11)
                return 'block';
              if(img_num == 12)
                return 'nblock';
              if(img_num == 13)
                return 'block';
              if(img_num == 14)
                return 'block';
              if(img_num == 15)
                return 'none';
              if(img_num == 16)
                return 'none';
            }
      
      return '0%';
    }

    const findBackground = (img_num) => {
      if(option.name.includes('Just an 8x10'))
      {
        //1050 x 570
        if(img_num == 1)
          return null;
        if(img_num == 2)
          return null;
        if(img_num == 3)
          return null;
        if(img_num == 4)
          return null;
        if(img_num == 5)
          return null;
        if(img_num == 6)
          return null;
        if(img_num == 7)
          return null;
        if(img_num == 8)
          return null;
        if(img_num == 9)
          return null;
        if(img_num == 10)
          return null;
        if(img_num == 11)
          return null;
        if(img_num == 12)
          return null;
        if(img_num == 13)
          return null;
        if(img_num == 14)
          return null;
        if(img_num == 15)
          return null;
      }
      if(option.name.includes('Picture Perfect Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return null;
        if(img_num == 2)
          return null;
        if(img_num == 3)
          return null;
        if(img_num == 4)
          return null;
        if(img_num == 5)
          return null;
        if(img_num == 6)
          return null;
        if(img_num == 7)
          return null;
        if(img_num == 8)
          return null;
        if(img_num == 9)
          return null;
        if(img_num == 10)
          return null;
        if(img_num == 11)
          return null;
        if(img_num == 12)
          return null;
        if(img_num == 13)
          return null;
        if(img_num == 14)
          return null;
        if(img_num == 15)
          return null;
      }
      if(option.name.includes('Gifts for Everyone Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return null;
        if(img_num == 2)
          return null;
        if(img_num == 3)
          return null;
        if(img_num == 4)
          return null;
        if(img_num == 5)
          return null;
        if(img_num == 6)
          return null;
        if(img_num == 7)
          return null;
        if(img_num == 8)
          return null;
        if(img_num == 9)
          return null;
        if(img_num == 10)
          return null;
        if(img_num == 11)
          return null;
        if(img_num == 12)
          return null;
        if(img_num == 13)
          return null;
        if(img_num == 14)
          return null;
        if(img_num == 15)
          return null;
      }
      if(option.name.includes('The Keepsake Collection'))
      {
        //1050 x 570
        if(img_num == 1)
          return null;
        if(img_num == 2)
          return null;
        if(img_num == 3)
          return null;
        if(img_num == 4)
          return null;
        if(img_num == 5)
          return null;
        if(img_num == 6)
          return null;
        if(img_num == 7)
          return null;
        if(img_num == 8)
          return null;
        if(img_num == 9)
          return null;
        if(img_num == 10)
          return null;
        if(img_num == 11)
          return null;
        if(img_num == 12)
          return null;
        if(img_num == 13)
          return null;
        if(img_num == 14)
          return null;
        if(img_num == 15)
          return null;
      }
      if(option.name.includes('All Digital Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return null;
        if(img_num == 2)
          return null;
        if(img_num == 3)
          return null;
        if(img_num == 4)
          return null;
        if(img_num == 5)
          return null;
        if(img_num == 6)
          return null;
        if(img_num == 7)
          return null;
        if(img_num == 8)
          return null;
        if(img_num == 9)
          return null;
        if(img_num == 10)
          return null;
        if(img_num == 11)
          return null;
        if(img_num == 12)
          return null;
        if(img_num == 13)
          return null;
        if(img_num == 14)
          return null;
        if(img_num == 15)
          return null;
      }
      if(option.name.includes('School Days Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return null;
        if(img_num == 2)
          return null;
        if(img_num == 3)
          return null;
        if(img_num == 4)
          return null;
        if(img_num == 5)
          return null;
        if(img_num == 6)
          return null;
        if(img_num == 7)
          return null;
        if(img_num == 8)
          return null;
        if(img_num == 9)
          return null;
        if(img_num == 10)
          return null;
        if(img_num == 11)
          return null;
        if(img_num == 12)
          return null;
        if(img_num == 13)
          return null;
        if(img_num == 14)
          return null;
        if(img_num == 15)
          return null;
      }
      if(option.name.includes('Basic Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return null;
        if(img_num == 2)
          return null;
        if(img_num == 3)
          return null;
        if(img_num == 4)
          return null;
        if(img_num == 5)
          return null;
        if(img_num == 6)
          return null;
        if(img_num == 7)
          return null;
        if(img_num == 8)
          return null;
        if(img_num == 9)
          return null;
        if(img_num == 10)
          return null;
        if(img_num == 11)
          return null;
        if(img_num == 12)
          return null;
        if(img_num == 13)
          return null;
        if(img_num == 14)
          return null;
        if(img_num == 15)
          return null;
      }

      //before Fall2026
      if (option.name.includes('Basic') && packageId == 629)
        {
          if(img_num == 1)
            return null;
          if(img_num == 2)
            return null;
          if(img_num == 3)
            return null;
          if(img_num == 4)
            return null;
          if(img_num == 5)
            return null;
          if(img_num == 6)
            return null;
          if(img_num == 7)
            return null;
          if(img_num == 8)
            return null;
          if(img_num == 9)
            return null;
          if(img_num == 10)
            return null;
          if(img_num == 11)
            return null;
          if(img_num == 12)
            return null;
          if(img_num == 13)
            return null;
          if(img_num == 14)
            return null;
          if(img_num == 15)
            return null;
          
          
        }
      if (option.name.includes('Star') && packageId == 629)
        {
          if(img_num == 1)
            return null;
          if(img_num == 2)
            return null;
          if(img_num == 3)
            return null;
          if(img_num == 4)
            return null;
          if(img_num == 5)
            return null;
          if(img_num == 6)
            return null;
          if(img_num == 7)
            return null;
          if(img_num == 8)
            return null;
          if(img_num == 9)
            return null;
          if(img_num == 10)
            return null;
          if(img_num == 11)
            return null;
          if(img_num == 12)
            return null;
          if(img_num == 13)
            return null;
          if(img_num == 14)
            return null;
          if(img_num == 15)
            return null;
          if(img_num == 16)
            return null;
          
        }
      if (option.name.includes('Perfect') && packageId == 629)
        {
          if(img_num == 1)
            return null;
          if(img_num == 2)
            return null;
          if(img_num == 3)
            return null;
          if(img_num == 4)
            return null;
          if(img_num == 5)
            return null;
          if(img_num == 6)
            return null;
          if(img_num == 7)
            return null;
          if(img_num == 8)
            return null;
          if(img_num == 9)
            return null;
          
        }
      if (option.name.includes('Memo') && packageId == 629)
        {
          if(img_num == 1)
            return null;
          if(img_num == 2)
            return null;
          if(img_num == 3)
            return null;
          if(img_num == 4)
            return null;
          if(img_num == 5)
            return null;
          if(img_num == 6)
            return null;
          if(img_num == 7)
            return null;
          if(img_num == 8)
            return null;
          if(img_num == 9)
            return null;
          if(img_num == 10)
            return null;
          if(img_num == 11)
            return null;
          if(img_num == 12)
            return null;
          if(img_num == 13)
            return null;
          if(img_num == 14)
            return null;
          if(img_num == 15)
            return null;
          
        }
      if (option.name.includes('Days') && packageId == 629)
        {
          if(img_num == 1)
            return null;
          if(img_num == 2)
            return null;
          if(img_num == 3)
            return null;
          
        }
      if (option.name.includes('Digital') && packageId == 629)
        {
          if(img_num == 1)
            return null;
          if(img_num == 2)
            return null;
          
          
        }
      if (option.name.includes('Just') && packageId == 629)
        {
          if(img_num == 1)
            return blueBg;
          if(img_num == 2)
            return null;
          if(img_num == 3)
            return blueBg;
          
        }
      if (option.name.includes('Star') && packageId == 549)
        {
          if(img_num == 1)
            return blueBg;
          if(img_num == 2)
            return chalkboardBg;
          if(img_num == 3)
            return chalkboardBg;
          if(img_num == 4)
            return classroomBg;
          if(img_num == 5)
            return classroomBg;
          if(img_num == 6)
            return classroomBg;
          if(img_num == 7)
            return classroomBg;
          if(img_num == 8)
            return classroomBg;
          if(img_num == 9)
            return classroomBg;
          if(img_num == 10)
            return classroomBg;
          if(img_num == 11)
            return classroomBg;
          if(img_num == 12)
            return grayBg;
          if(img_num == 13)
            return blueBg;
          if(img_num == 14)
            return blueBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('Memories') && packageId == 549)
        {
          if(img_num == 1)
            return fallleaves;
          if(img_num == 2)
            return fallleaves;
          if(img_num == 3)
            return mochaBg;
          if(img_num == 4)
            return tealBg;
          if(img_num == 5)
            return tealBg;
          if(img_num == 6)
            return tealBg;
          if(img_num == 7)
            return tealBg;
          if(img_num == 8)
            return tealBg;
          if(img_num == 9)
            return tealBg;
          if(img_num == 10)
            return tealBg;
          if(img_num == 11)
            return tealBg;
          if(img_num == 12)
            return grayBg;
          if(img_num == 13)
            return blueBg;
          if(img_num == 14)
            return blueBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('Picture') && packageId == 549)
        {
          if(img_num == 1)
            return brownBg;
          if(img_num == 2)
            return grayBg;
          if(img_num == 3)
            return grayBg;
          if(img_num == 4)
            return blueBg;
          if(img_num == 5)
            return blueBg;
          if(img_num == 6)
            return blueBg;
          if(img_num == 7)
            return blueBg;
          if(img_num == 8)
            return blueBg;
          if(img_num == 9)
            return blueBg;
          if(img_num == 10)
            return blueBg;
          if(img_num == 11)
            return blueBg;
          if(img_num == 12)
            return fallleaves;
          if(img_num == 13)
            return blueBg;
          if(img_num == 14)
            return blueBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('School') && packageId == 549)
        {
          if(img_num == 1)
            return classroomBg;
          if(img_num == 2)
            return blueBg;
          if(img_num == 3)
            return blueBg;
          if(img_num == 4)
            return blueBg;
          if(img_num == 5)
            return grayBg;
          if(img_num == 6)
            return grayBg;
          if(img_num == 7)
            return grayBg;
          if(img_num == 8)
            return grayBg;
          if(img_num == 9)
            return blueBg;
          if(img_num == 10)
            return blueBg;
          if(img_num == 11)
            return classroomBg;
          if(img_num == 12)
            return classroomBg;
          if(img_num == 13)
            return classroomBg;
          if(img_num == 14)
            return classroomBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('Basic') && packageId == 549)
        {
          if(img_num == 1)
            return grayBg;
          if(img_num == 2)
            return grayBg;
          if(img_num == 3)
            return grayBg;
          if(img_num == 4)
            return grayBg;
          if(img_num == 5)
            return grayBg;
          if(img_num == 6)
            return grayBg;
          if(img_num == 7)
            return grayBg;
          if(img_num == 8)
            return grayBg;
          if(img_num == 9)
            return blueBg;
          if(img_num == 10)
            return blueBg;
          if(img_num == 11)
            return classroomBg;
          if(img_num == 12)
            return classroomBg;
          if(img_num == 13)
            return classroomBg;
          if(img_num == 14)
            return classroomBg;
          if(img_num == 15)
            return '49%';
        }
        if (option.name.includes('8x10') && (packageId == 550 || packageId == 549))
          {
            return blueBg;
          }
      if (option.name.includes('Star') && packageId == 550)
        {
          if(img_num == 1)
            return blueBg;
          if(img_num == 2)
            return chalkboardBg;
          if(img_num == 3)
            return chalkboardBg;
          if(img_num == 4)
            return classroomBg;
          if(img_num == 5)
            return classroomBg;
          if(img_num == 6)
            return classroomBg;
          if(img_num == 7)
            return classroomBg;
          if(img_num == 8)
            return classroomBg;
          if(img_num == 9)
            return classroomBg;
          if(img_num == 10)
            return classroomBg;
          if(img_num == 11)
            return classroomBg;
          if(img_num == 12)
            return grayBg;
          if(img_num == 13)
            return blueBg;
          if(img_num == 14)
            return blueBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('Memories') && packageId == 550)
        {
          if(img_num == 1)
            return fallleaves;
          if(img_num == 2)
            return fallleaves;
          if(img_num == 3)
            return mochaBg;
          if(img_num == 4)
            return tealBg;
          if(img_num == 5)
            return tealBg;
          if(img_num == 6)
            return tealBg;
          if(img_num == 7)
            return tealBg;
          if(img_num == 8)
            return tealBg;
          if(img_num == 9)
            return tealBg;
          if(img_num == 10)
            return tealBg;
          if(img_num == 11)
            return tealBg;
          if(img_num == 12)
            return grayBg;
          if(img_num == 13)
            return blueBg;
          if(img_num == 14)
            return blueBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('Picture') && packageId == 550)
        {
          if(img_num == 1)
            return brownBg;
          if(img_num == 2)
            return grayBg;
          if(img_num == 3)
            return grayBg;
          if(img_num == 4)
            return blueBg;
          if(img_num == 5)
            return blueBg;
          if(img_num == 6)
            return blueBg;
          if(img_num == 7)
            return blueBg;
          if(img_num == 8)
            return blueBg;
          if(img_num == 9)
            return blueBg;
          if(img_num == 10)
            return blueBg;
          if(img_num == 11)
            return blueBg;
          if(img_num == 12)
            return fallleaves;
          if(img_num == 13)
            return blueBg;
          if(img_num == 14)
            return blueBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('School') && packageId == 550)
        {
          if(img_num == 1)
            return classroomBg;
          if(img_num == 2)
            return blueBg;
          if(img_num == 3)
            return blueBg;
          if(img_num == 4)
            return blueBg;
          if(img_num == 5)
            return grayBg;
          if(img_num == 6)
            return grayBg;
          if(img_num == 7)
            return grayBg;
          if(img_num == 8)
            return grayBg;
          if(img_num == 9)
            return blueBg;
          if(img_num == 10)
            return blueBg;
          if(img_num == 11)
            return classroomBg;
          if(img_num == 12)
            return classroomBg;
          if(img_num == 13)
            return classroomBg;
          if(img_num == 14)
            return classroomBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('Basic') && packageId == 550)
        {
          if(img_num == 1)
            return grayBg;
          if(img_num == 2)
            return grayBg;
          if(img_num == 3)
            return grayBg;
          if(img_num == 4)
            return grayBg;
          if(img_num == 5)
            return grayBg;
          if(img_num == 6)
            return grayBg;
          if(img_num == 7)
            return grayBg;
          if(img_num == 8)
            return grayBg;
          if(img_num == 9)
            return blueBg;
          if(img_num == 10)
            return blueBg;
          if(img_num == 11)
            return classroomBg;
          if(img_num == 12)
            return classroomBg;
          if(img_num == 13)
            return classroomBg;
          if(img_num == 14)
            return classroomBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('Star') && packageId == 616)
        {
          if(img_num == 1)
            return blueBg;
          if(img_num == 2)
            return chalkboardBg;
          if(img_num == 3)
            return chalkboardBg;
          if(img_num == 4)
            return classroomBg;
          if(img_num == 5)
            return classroomBg;
          if(img_num == 6)
            return classroomBg;
          if(img_num == 7)
            return classroomBg;
          if(img_num == 8)
            return classroomBg;
          if(img_num == 9)
            return classroomBg;
          if(img_num == 10)
            return classroomBg;
          if(img_num == 11)
            return classroomBg;
          if(img_num == 12)
            return grayBg;
          if(img_num == 13)
            return blueBg;
          if(img_num == 14)
            return blueBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('Memories') && packageId == 616)
        {
          if(img_num == 1)
            return fallleaves;
          if(img_num == 2)
            return fallleaves;
          if(img_num == 3)
            return mochaBg;
          if(img_num == 4)
            return tealBg;
          if(img_num == 5)
            return tealBg;
          if(img_num == 6)
            return tealBg;
          if(img_num == 7)
            return tealBg;
          if(img_num == 8)
            return tealBg;
          if(img_num == 9)
            return tealBg;
          if(img_num == 10)
            return tealBg;
          if(img_num == 11)
            return tealBg;
          if(img_num == 12)
            return grayBg;
          if(img_num == 13)
            return blueBg;
          if(img_num == 14)
            return blueBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('Picture') && packageId == 616)
        {
          if(img_num == 1)
            return brownBg;
          if(img_num == 2)
            return grayBg;
          if(img_num == 3)
            return grayBg;
          if(img_num == 4)
            return blueBg;
          if(img_num == 5)
            return blueBg;
          if(img_num == 6)
            return blueBg;
          if(img_num == 7)
            return blueBg;
          if(img_num == 8)
            return blueBg;
          if(img_num == 9)
            return blueBg;
          if(img_num == 10)
            return blueBg;
          if(img_num == 11)
            return blueBg;
          if(img_num == 12)
            return fallleaves;
          if(img_num == 13)
            return blueBg;
          if(img_num == 14)
            return blueBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('School') && packageId == 616)
        {
          if(img_num == 1)
            return classroomBg;
          if(img_num == 2)
            return blueBg;
          if(img_num == 3)
            return blueBg;
          if(img_num == 4)
            return blueBg;
          if(img_num == 5)
            return grayBg;
          if(img_num == 6)
            return grayBg;
          if(img_num == 7)
            return grayBg;
          if(img_num == 8)
            return grayBg;
          if(img_num == 9)
            return blueBg;
          if(img_num == 10)
            return blueBg;
          if(img_num == 11)
            return classroomBg;
          if(img_num == 12)
            return classroomBg;
          if(img_num == 13)
            return classroomBg;
          if(img_num == 14)
            return classroomBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('Basic') && packageId == 616)
        {
          if(img_num == 1)
            return grayBg;
          if(img_num == 2)
            return grayBg;
          if(img_num == 3)
            return grayBg;
          if(img_num == 4)
            return grayBg;
          if(img_num == 5)
            return grayBg;
          if(img_num == 6)
            return grayBg;
          if(img_num == 7)
            return grayBg;
          if(img_num == 8)
            return grayBg;
          if(img_num == 9)
            return blueBg;
          if(img_num == 10)
            return blueBg;
          if(img_num == 11)
            return classroomBg;
          if(img_num == 12)
            return classroomBg;
          if(img_num == 13)
            return classroomBg;
          if(img_num == 14)
            return classroomBg;
          if(img_num == 15)
            return '49%';
        }
        if (option.name.includes('8x10') && (packageId == 611 || packageId == 616))
          {
            return blueBg;
          }
      if (option.name.includes('Star') && packageId == 611)
        {
          if(img_num == 1)
            return blueBg;
          if(img_num == 2)
            return chalkboardBg;
          if(img_num == 3)
            return chalkboardBg;
          if(img_num == 4)
            return classroomBg;
          if(img_num == 5)
            return classroomBg;
          if(img_num == 6)
            return classroomBg;
          if(img_num == 7)
            return classroomBg;
          if(img_num == 8)
            return classroomBg;
          if(img_num == 9)
            return classroomBg;
          if(img_num == 10)
            return classroomBg;
          if(img_num == 11)
            return classroomBg;
          if(img_num == 12)
            return grayBg;
          if(img_num == 13)
            return blueBg;
          if(img_num == 14)
            return blueBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('Memories') && packageId == 611)
        {
          if(img_num == 1)
            return fallleaves;
          if(img_num == 2)
            return fallleaves;
          if(img_num == 3)
            return mochaBg;
          if(img_num == 4)
            return tealBg;
          if(img_num == 5)
            return tealBg;
          if(img_num == 6)
            return tealBg;
          if(img_num == 7)
            return tealBg;
          if(img_num == 8)
            return tealBg;
          if(img_num == 9)
            return tealBg;
          if(img_num == 10)
            return tealBg;
          if(img_num == 11)
            return tealBg;
          if(img_num == 12)
            return grayBg;
          if(img_num == 13)
            return blueBg;
          if(img_num == 14)
            return blueBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('Picture') && packageId == 611)
        {
          if(img_num == 1)
            return brownBg;
          if(img_num == 2)
            return grayBg;
          if(img_num == 3)
            return grayBg;
          if(img_num == 4)
            return blueBg;
          if(img_num == 5)
            return blueBg;
          if(img_num == 6)
            return blueBg;
          if(img_num == 7)
            return blueBg;
          if(img_num == 8)
            return blueBg;
          if(img_num == 9)
            return blueBg;
          if(img_num == 10)
            return blueBg;
          if(img_num == 11)
            return blueBg;
          if(img_num == 12)
            return fallleaves;
          if(img_num == 13)
            return blueBg;
          if(img_num == 14)
            return blueBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('School') && packageId == 611)
        {
          if(img_num == 1)
            return classroomBg;
          if(img_num == 2)
            return blueBg;
          if(img_num == 3)
            return blueBg;
          if(img_num == 4)
            return blueBg;
          if(img_num == 5)
            return grayBg;
          if(img_num == 6)
            return grayBg;
          if(img_num == 7)
            return grayBg;
          if(img_num == 8)
            return grayBg;
          if(img_num == 9)
            return blueBg;
          if(img_num == 10)
            return blueBg;
          if(img_num == 11)
            return classroomBg;
          if(img_num == 12)
            return classroomBg;
          if(img_num == 13)
            return classroomBg;
          if(img_num == 14)
            return classroomBg;
          if(img_num == 15)
            return '49%';
        }
      if (option.name.includes('Basic') && packageId == 611)
        {
          if(img_num == 1)
            return grayBg;
          if(img_num == 2)
            return grayBg;
          if(img_num == 3)
            return grayBg;
          if(img_num == 4)
            return grayBg;
          if(img_num == 5)
            return grayBg;
          if(img_num == 6)
            return grayBg;
          if(img_num == 7)
            return grayBg;
          if(img_num == 8)
            return grayBg;
          if(img_num == 9)
            return blueBg;
          if(img_num == 10)
            return blueBg;
          if(img_num == 11)
            return classroomBg;
          if(img_num == 12)
            return classroomBg;
          if(img_num == 13)
            return classroomBg;
          if(img_num == 14)
            return classroomBg;
          if(img_num == 15)
            return '49%';
        }
      else if(option.name.includes('Ultimate'))
      {
        if(img_num == 1)
          return blueBg;
        if(img_num == 2)
          return grayBg;
        if(img_num == 3)
          return redBg;
        if(img_num == 4)
          return redBg;
        if(img_num == 5)
          return leavesBg;
        if(img_num == 6)
          return leavesBg;
        if(img_num == 7)
          return blueBg;
        if(img_num == 8)
          return greenBg;
        if(img_num == 9)
          return greenBg;
        if(img_num == 10)
          return greenBg;
        if(img_num == 11)
          return greenBg;
        if(img_num == 12)
          return 'block';
        if(img_num == 13)
          return 'block';
        if(img_num == 14)
          return 'block';
        if(img_num == 15)
          return 'block';
      }

      else if(option.name.includes('Scholar'))
        {
          if(img_num == 1)
            return grayBg;
          if(img_num == 2)
            return leavesBg;
          if(img_num == 3)
            return blueBg;
          if(img_num == 4)
            return greenBg;
          if(img_num == 5)
            return blueBg;
          if(img_num == 6)
            return mochaBg;
          if(img_num == 7)
            return mochaBg;
          if(img_num == 8)
            return mochaBg;
          if(img_num == 9)
            return mochaBg;
          if(img_num == 10)
            return 'block';
          if(img_num == 11)
            return 'block';
          if(img_num == 12)
            return 'block';
          if(img_num == 13)
            return 'block';
          if(img_num == 14)
            return 'block';
          if(img_num == 15)
            return 'block';
        }
        else if (option.name.includes('Senior Special'))
          {
            if(img_num == 1)
              return concreteBg;
            if(img_num == 2)
              return blueBg;
            if(img_num == 3)
              return brownBg;
            if(img_num == 4)
              return leavesBg;
            if(img_num == 5)
              return blueBg;
            if(img_num == 6)
              return redBg;
            if(img_num == 7)
              return redBg;
            if(img_num == 8)
              return redBg;
            if(img_num == 9)
              return redBg;
            if(img_num == 10)
              return redBg;
            if(img_num == 11)
              return redBg;
            if(img_num == 12)
              return redBg;
            if(img_num == 13)
              return redBg;
            if(img_num == 14)
              return brownBg;
            if(img_num == 15)
              return '49%';
          }
          else if (option.name.includes('Perfect Pack') && packageId == 610)
            {
              if(img_num == 1)
                return blueBg;
              if(img_num == 2)
                return blueBg;
              if(img_num == 3)
                return blueBg;
              if(img_num == 4)
                return blueBg;
              if(img_num == 5)
                return blueBg;
              if(img_num == 6)
                return blueBg;
              if(img_num == 7)
                return blueBg;
              if(img_num == 8)
                return blueBg;
              if(img_num == 9)
                return blueBg;
              if(img_num == 10)
                return springOrchard;
              if(img_num == 11)
                return blueBg;
              if(img_num == 12)
                return springOrchard;
              if(img_num == 13)
                return springOrchard;
              if(img_num == 14)
                return springOrchard;
              if(img_num == 15)
                return '49%';
            }
            else if (option.name.includes('Basic') && packageId == 610)
              {
                if(img_num == 1)
                  return springOrchard;
                if(img_num == 2)
                  return grayBg;
                if(img_num == 3)
                  return blueBg;
                if(img_num == 4)
                  return blueBg;
                if(img_num == 5)
                  return blueBg;
                if(img_num == 6)
                  return blueBg;
                if(img_num == 7)
                  return blueBg;
                if(img_num == 8)
                  return blueBg;
                if(img_num == 9)
                  return blueBg;
                if(img_num == 10)
                  return blueBg;
                if(img_num == 11)
                  return blueBg;
                if(img_num == 12)
                  return springOrchard;
                if(img_num == 13)
                  return springOrchard;
                if(img_num == 14)
                  return springOrchard;
                if(img_num == 15)
                  return '49%';
              }
              else if (option.name.includes('Just an 8') && packageId == 610)
                {
                  if(img_num == 1)
                    return blueBg;
                  
                }
                else if (option.name.includes('Just a D') && packageId == 610)
                  {
                    if(img_num == 1)
                      return blueBg;
                    
                  }
                  else if (option.name.includes('Digital A') && packageId == 610)
                    {
                      
                      if(img_num == 1)
                        return blueBg;
                      if(img_num == 2)
                        return grayBg;
                      if(img_num == 3)
                        return chalkboardBg;
                      if(img_num == 4)
                        return classroomBg;
                      if(img_num == 5)
                        return flowerfieldBg;
                      if(img_num == 6)
                        return springBirch;
                      if(img_num == 7)
                        return springstairsBg;
                      if(img_num == 8)
                        return springarchBg;
                      if(img_num == 9)
                        return blueBg;
                      if(img_num == 10)
                        return grayBg;
                      if(img_num == 11)
                        return chalkboardBg;
                      if(img_num == 12)
                        return classroomBg;
                      if(img_num == 13)
                        return flowerfieldBg;
                      if(img_num == 14)
                        return springBirch;
                      if(img_num == 15)
                        return springstairsBg;
                      if(img_num == 16)
                        return springarchBg;
                    }
            else if (option.name.includes('Something') && packageId == 610)
              {
                if(img_num == 1)
                  return springOrchard;
                if(img_num == 2)
                  return blueBg;
                if(img_num == 3)
                  return blueBg;
                if(img_num == 4)
                  return blueBg;
                if(img_num == 5)
                  return blueBg;
                if(img_num == 6)
                  return blueBg;
                if(img_num == 7)
                  return blueBg;
                if(img_num == 8)
                  return blueBg;
                if(img_num == 9)
                  return blueBg;
                if(img_num == 10)
                  return springOrchard;
                if(img_num == 11)
                  return blueBg;
                if(img_num == 12)
                  return blueBg;
                if(img_num == 13)
                  return springOrchard;
                if(img_num == 14)
                  return springOrchard;
                if(img_num == 15)
                  return blueBg;
                if(img_num == 16)
                  return blueBg;
              }
            else if (option.name.includes('Double Double') && packageId == 610)
              {
                if(img_num == 1)
                  return blueBg;
                if(img_num == 2)
                  return springOrchard;
                if(img_num == 3)
                  return blueBg;
                if(img_num == 4)
                  return springOrchard;
                if(img_num == 5)
                  return blueBg;
                if(img_num == 6)
                  return blueBg;
                if(img_num == 7)
                  return blueBg;
                if(img_num == 8)
                  return blueBg;
                if(img_num == 9)
                  return blueBg;
                if(img_num == 10)
                  return springOrchard;
                if(img_num == 11)
                  return blueBg;
                if(img_num == 12)
                  return springOrchard;
                if(img_num == 13)
                  return springOrchard;
                if(img_num == 14)
                  return springOrchard;
                if(img_num == 15)
                  return '49%';
              }
          else if (option.name.includes('Standard Package'))
            {
              if(img_num == 1)
                return blueBg;
              if(img_num == 2)
                return grayBg;
              if(img_num == 3)
                return grayBg;
              if(img_num == 4)
                return brownBg;
              if(img_num == 5)
                return brownBg;
              if(img_num == 6)
                return brownBg;
              if(img_num == 7)
                return brownBg;
              if(img_num == 8)
                return brownBg;
              if(img_num == 9)
                return brownBg;
              if(img_num == 10)
                return brownBg;
              if(img_num == 11)
                return brownBg;
              if(img_num == 12)
                return leavesBg;
              if(img_num == 13)
                return leavesBg;
              if(img_num == 14)
                return leavesBg;
              if(img_num == 15)
                return leavesBg;
            }
            else if (option.name.includes('Economy Selection'))
              {
                if(img_num == 1)
                  return grayBg;
                if(img_num == 2)
                  return grayBg;
                if(img_num == 3)
                  return blueBg;
                if(img_num == 4)
                  return blueBg;
                if(img_num == 5)
                  return blueBg;
                if(img_num == 6)
                  return blueBg;
                if(img_num == 7)
                  return blueBg;
                if(img_num == 8)
                  return blueBg;
                if(img_num == 9)
                  return blueBg;
                if(img_num == 10)
                  return blueBg;
                if(img_num == 11)
                  return leavesBg;
                if(img_num == 12)
                  return leavesBg;
                if(img_num == 13)
                  return leavesBg;
                if(img_num == 14)
                  return leavesBg;
                if(img_num == 15)
                  return 'none';
              }
      
      return '0%';
    }
  
    
    
    
    const pose1 = poses[0].imageUrl;

    // Get vertical poses only (width <= height)
    const verticalPoses = poses.filter(p => !isHorizontal(p.imageUrl));
    const getVerticalPose = () => {
      if (verticalPoses.length === 0) return poses[getRandomIndex(poses)].imageUrl;
      return verticalPoses[getRandomIndex(verticalPoses)].imageUrl;
    };

    var pose2 = getVerticalPose();
    var pose3 = getVerticalPose();
    var pose4 = getVerticalPose();
    console.log('pose1:', pose1);
    console.log('pose2:', pose2);
    console.log('pose3:', pose3);
    console.log('pose4:', pose4);
      var pindex = 0;
      var poseHoriz = poses[pindex].imageUrl;
      if (poses[pindex].imageUrl.toLowerCase().includes('-spr0'))
      {

        while(poses.length > pindex && !poseHoriz.includes('51.png'))
          {
            
            poseHoriz = poses[pindex].imageUrl;
            pindex = pindex + 1;
          }
      }
      if (pindex >= poses.length) pindex = poses.length - 1;
      if (poses[pindex].imageUrl.includes('U0') || poses[pindex].imageUrl.includes('J0') || poses[pindex].imageUrl.includes('E0')  )
      {

        while(poses.length > pindex && !poseHoriz.includes('25.jpg'))
          {

            poseHoriz = poses[pindex].imageUrl;
            pindex = pindex + 1;
          }
      }
      if (pindex >= poses.length) pindex = poses.length - 1;

      if(packageId == 610)
        {
          // Filter for vertical poses excluding spring poses
          const verticalNonSpring = poses.filter(p => !isHorizontal(p.imageUrl) && !p.imageUrl.includes('-spr0'));
          const getVerticalNonSpring = () => {
            if (verticalNonSpring.length === 0) return poses[getRandomIndex(poses)].imageUrl;
            return verticalNonSpring[getRandomIndex(verticalNonSpring)].imageUrl;
          };

          // Filter for vertical poses excluding e0 poses
          const verticalNonE0 = poses.filter(p => !isHorizontal(p.imageUrl) && !p.imageUrl.includes('-e0'));
          const getVerticalNonE0 = () => {
            if (verticalNonE0.length === 0) return poses[getRandomIndex(poses)].imageUrl;
            return verticalNonE0[getRandomIndex(verticalNonE0)].imageUrl;
          };

          var pose2 = getVerticalNonSpring();
          var pose3 = getVerticalNonSpring();
          var springpose1 = getVerticalNonE0();
          var springpose2 = getVerticalNonE0();
        }

    const findPose = (img_num) => {
      if(option.name.includes('Just an 8x10'))
      {
        //1050 x 570
        if(img_num == 1)
          return pose2;
        if(img_num == 2)
          return pose2;
        if(img_num == 3)
          return pose2;
        if(img_num == 4)
          return pose2;
        if(img_num == 5)
          return pose2;
        if(img_num == 6)
          return pose2;
        if(img_num == 7)
          return pose2;
        if(img_num == 8)
          return pose2;
        if(img_num == 9)
          return pose2;
        if(img_num == 10)
          return pose2;
        if(img_num == 11)
          return pose2;
        if(img_num == 12)
          return pose2;
        if(img_num == 13)
          return pose2;
        if(img_num == 14)
          return poseHoriz;
        if(img_num == 15)
          return pose2;
      }
      if(option.name.includes('Picture Perfect Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return pose2;
        if(img_num == 2)
          return pose1;
        if(img_num == 3)
          return pose1;
        if(img_num == 4)
          return pose1;
        if(img_num == 5)
          return pose1;
        if(img_num == 6)
          return pose3;
        if(img_num == 7)
          return pose3;
        if(img_num == 8)
          return pose3;
        if(img_num == 9)
          return pose3;
        if(img_num == 10)
          return pose3;
        if(img_num == 11)
          return pose3;
        if(img_num == 12)
          return pose3;
        if(img_num == 13)
          return pose3;
        if(img_num == 14)
          return poseHoriz;
        if(img_num == 15)
          return pose2;
      }
      if(option.name.includes('Gifts for Everyone Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return pose4;
        if(img_num == 2)
          return pose4;
        if(img_num == 3)
          return pose2;
        if(img_num == 4)
          return pose2;
        if(img_num == 5)
          return pose3;
        if(img_num == 6)
          return pose3;
        if(img_num == 7)
          return pose4;
        if(img_num == 8)
          return pose4;
        
          return pose2;
      }
      if(option.name.includes('The Keepsake Collection'))
      {
        //1050 x 570
        if(img_num == 1)
          return pose4;
        if(img_num == 2)
          return pose2;
        if(img_num == 3)
          return pose3;
        if(img_num == 4)
          return pose3;
        if(img_num == 5)
          return pose4;
        if(img_num == 6)
          return pose4;
        if(img_num == 7)
          return pose3;
        if(img_num == 8)
          return pose2;
        if(img_num == 9)
          return pose2;
        if(img_num == 10)
          return pose2;
        if(img_num == 11)
          return pose2;
        if(img_num == 12)
          return pose2;
        if(img_num == 13)
          return pose2;
        if(img_num == 14)
          return pose2;
        if(img_num == 15)
          return pose2;
      }
      if(option.name.includes('All Digital Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return pose4;
        if(img_num == 2)
          return pose2;
        if(img_num == 3)
          return poseHoriz;
        if(img_num == 4)
          return pose3;
        
          return pose2;
      }
      if(option.name.includes('School Days Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return pose4;
        if(img_num == 2)
          return pose2;
        if(img_num == 3)
          return pose3;
        
          return pose2;
      }
      if(option.name.includes('Basic Package'))
      {
        //1050 x 570
        if(img_num == 1)
          return pose1;
        if(img_num == 2)
          return pose1;
        if(img_num == 3)
          return pose1;
        if(img_num == 4)
          return pose2;
        if(img_num == 5)
          return pose2;
        if(img_num == 6)
          return pose2;
        if(img_num == 7)
          return pose2;
        if(img_num == 8)
          return pose2;
        if(img_num == 9)
          return pose2;
        if(img_num == 10)
          return pose2;
        if(img_num == 11)
          return pose2;
        
          return pose2;
      }

      //before Fall2026
      if (option.name.includes('Basic') && packageId == 629)
        {
          if(img_num == 1)
            return pose2;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose2;
          if(img_num == 4)
            return pose2;
          if(img_num == 5)
            return pose2;
          if(img_num == 6)
            return pose2;
          if(img_num == 7)
            return pose2;
          if(img_num == 8)
            return pose2;
          if(img_num == 9)
            return pose2;
          if(img_num == 10)
            return pose2;
          if(img_num == 11)
            return pose1;
          if(img_num == 12)
            return pose1;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return pose1;
          
          
        }
      if (option.name.includes('Star') && packageId == 629)
        {
          if(img_num == 1)
            return pose2;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose2;
          if(img_num == 4)
            return pose2;
          if(img_num == 5)
            return pose2;
          if(img_num == 6)
            return pose2;
          if(img_num == 7)
            return pose2;
          if(img_num == 8)
            return pose2;
          if(img_num == 9)
            return pose2;
          if(img_num == 10)
            return pose2;
          if(img_num == 11)
            return pose2;
          if(img_num == 12)
            return pose2;
          if(img_num == 13)
            return pose2;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return pose1;
          if(img_num == 16)
            return pose1;
          
        }
      if (option.name.includes('Perfect') && packageId == 629)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose1;
          if(img_num == 3)
            return pose1;
          if(img_num == 4)
            return pose2;
          if(img_num == 5)
            return pose2;
          if(img_num == 6)
            return pose2;
          if(img_num == 7)
            return pose2;
          if(img_num == 8)
            return pose2;
          if(img_num == 9)
            return pose2;
          
          
        }
      if (option.name.includes('Memo') && packageId == 629)
        {
          if(img_num == 1)
            return pose2;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose2;
          if(img_num == 4)
            return pose2;
          if(img_num == 5)
            return pose2;
          if(img_num == 6)
            return pose2;
          if(img_num == 7)
            return pose2;
          if(img_num == 8)
            return pose2;
          if(img_num == 9)
            return pose2;
          if(img_num == 10)
            return pose2;
          if(img_num == 11)
            return pose1;
          if(img_num == 12)
            return pose1;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return pose1;
          
        }
      if(option.name.includes('Memo') && packageId == 629)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose2;
          
        }
      if(option.name.includes('Days') && packageId == 629)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose2;
          
        }
      if(option.name.includes('Digital') && packageId == 629)
        {
          if(img_num == 1)
            return pose2;
          if(img_num == 2)
            return pose1;
          
          
        }
      if(option.name.includes('Just') && packageId == 629)
        {
          if(img_num == 1)
            return pose2;
          if(img_num == 2)
            return pose1;
          if(img_num == 3)
            return pose2;
          
        }
      if(option.name.includes('Star') && packageId == 549)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose2;
          if(img_num == 4)
            return pose1;
          if(img_num == 5)
            return pose1;
          if(img_num == 6)
            return pose1;
          if(img_num == 7)
            return pose1;
          if(img_num == 8)
            return pose1;
          if(img_num == 9)
            return pose1;
          if(img_num == 10)
            return pose1;
          if(img_num == 11)
            return pose1;
          if(img_num == 12)
            return pose2;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
      if(option.name.includes('Memories') && packageId == 549)
        {
          if(img_num == 1)
            return pose2;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose1;
          if(img_num == 4)
            return pose2;
          if(img_num == 5)
            return pose2;
          if(img_num == 6)
            return pose2;
          if(img_num == 7)
            return pose2;
          if(img_num == 8)
            return pose2;
          if(img_num == 9)
            return pose2;
          if(img_num == 10)
            return pose2;
          if(img_num == 11)
            return pose2;
          if(img_num == 12)
            return pose1;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
      if(option.name.includes('Picture') && packageId == 549)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose2;
          if(img_num == 4)
            return pose1;
          if(img_num == 5)
            return pose1;
          if(img_num == 6)
            return pose1;
          if(img_num == 7)
            return pose1;
          if(img_num == 8)
            return pose1;
          if(img_num == 9)
            return pose1;
          if(img_num == 10)
            return pose1;
          if(img_num == 11)
            return pose1;
          if(img_num == 12)
            return pose2;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
      if(option.name.includes('Basic') && packageId == 549)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose1;
          if(img_num == 3)
            return pose1;
          if(img_num == 4)
            return pose1;
          if(img_num == 5)
            return pose1;
          if(img_num == 6)
            return pose1;
          if(img_num == 7)
            return pose1;
          if(img_num == 8)
            return pose1;
          if(img_num == 9)
            return pose2;
          if(img_num == 10)
            return pose2;
          if(img_num == 11)
            return pose1;
          if(img_num == 12)
            return pose1;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
        if(option.name.includes('School') && packageId == 549)
          {
            if(img_num == 1)
              return pose1;
            if(img_num == 2)
              return pose2;
            if(img_num == 3)
              return pose2;
            if(img_num == 4)
              return pose1;
            if(img_num == 5)
              return pose1;
            if(img_num == 6)
              return pose1;
            if(img_num == 7)
              return pose1;
            if(img_num == 8)
              return pose1;
            if(img_num == 9)
              return pose2;
            if(img_num == 10)
              return pose2;
            if(img_num == 11)
              return pose1;
            if(img_num == 12)
              return pose1;
            if(img_num == 13)
              return pose1;
            if(img_num == 14)
              return pose1;
            if(img_num == 15)
              return 'block';
          }
          if(option.name.includes('8x10') && (packageId == 550 || packageId == 549))
            {
              
                return pose1;
            }
      if(option.name.includes('Star') && packageId == 550)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose2;
          if(img_num == 4)
            return pose1;
          if(img_num == 5)
            return pose1;
          if(img_num == 6)
            return pose1;
          if(img_num == 7)
            return pose1;
          if(img_num == 8)
            return pose1;
          if(img_num == 9)
            return pose1;
          if(img_num == 10)
            return pose1;
          if(img_num == 11)
            return pose1;
          if(img_num == 12)
            return pose2;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
      if(option.name.includes('Memories') && packageId == 550)
        {
          if(img_num == 1)
            return pose2;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose1;
          if(img_num == 4)
            return pose2;
          if(img_num == 5)
            return pose2;
          if(img_num == 6)
            return pose2;
          if(img_num == 7)
            return pose2;
          if(img_num == 8)
            return pose2;
          if(img_num == 9)
            return pose2;
          if(img_num == 10)
            return pose2;
          if(img_num == 11)
            return pose2;
          if(img_num == 12)
            return pose1;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
      if(option.name.includes('Picture') && packageId == 550)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose2;
          if(img_num == 4)
            return pose1;
          if(img_num == 5)
            return pose1;
          if(img_num == 6)
            return pose1;
          if(img_num == 7)
            return pose1;
          if(img_num == 8)
            return pose1;
          if(img_num == 9)
            return pose1;
          if(img_num == 10)
            return pose1;
          if(img_num == 11)
            return pose1;
          if(img_num == 12)
            return pose2;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
      if(option.name.includes('Basic') && packageId == 550)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose1;
          if(img_num == 3)
            return pose1;
          if(img_num == 4)
            return pose1;
          if(img_num == 5)
            return pose1;
          if(img_num == 6)
            return pose1;
          if(img_num == 7)
            return pose1;
          if(img_num == 8)
            return pose1;
          if(img_num == 9)
            return pose2;
          if(img_num == 10)
            return pose2;
          if(img_num == 11)
            return pose1;
          if(img_num == 12)
            return pose1;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
        if(option.name.includes('School') && packageId == 550)
          {
            if(img_num == 1)
              return pose1;
            if(img_num == 2)
              return pose2;
            if(img_num == 3)
              return pose2;
            if(img_num == 4)
              return pose1;
            if(img_num == 5)
              return pose1;
            if(img_num == 6)
              return pose1;
            if(img_num == 7)
              return pose1;
            if(img_num == 8)
              return pose1;
            if(img_num == 9)
              return pose2;
            if(img_num == 10)
              return pose2;
            if(img_num == 11)
              return pose1;
            if(img_num == 12)
              return pose1;
            if(img_num == 13)
              return pose1;
            if(img_num == 14)
              return pose1;
            if(img_num == 15)
              return 'block';
          }
      if(option.name.includes('Star') && packageId == 616)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose2;
          if(img_num == 4)
            return pose1;
          if(img_num == 5)
            return pose1;
          if(img_num == 6)
            return pose1;
          if(img_num == 7)
            return pose1;
          if(img_num == 8)
            return pose1;
          if(img_num == 9)
            return pose1;
          if(img_num == 10)
            return pose1;
          if(img_num == 11)
            return pose1;
          if(img_num == 12)
            return pose2;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
      if(option.name.includes('Memories') && packageId == 616)
        {
          if(img_num == 1)
            return pose2;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose1;
          if(img_num == 4)
            return pose2;
          if(img_num == 5)
            return pose2;
          if(img_num == 6)
            return pose2;
          if(img_num == 7)
            return pose2;
          if(img_num == 8)
            return pose2;
          if(img_num == 9)
            return pose2;
          if(img_num == 10)
            return pose2;
          if(img_num == 11)
            return pose2;
          if(img_num == 12)
            return pose1;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
      if(option.name.includes('Picture') && packageId == 616)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose2;
          if(img_num == 4)
            return pose1;
          if(img_num == 5)
            return pose1;
          if(img_num == 6)
            return pose1;
          if(img_num == 7)
            return pose1;
          if(img_num == 8)
            return pose1;
          if(img_num == 9)
            return pose1;
          if(img_num == 10)
            return pose1;
          if(img_num == 11)
            return pose1;
          if(img_num == 12)
            return pose2;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
      if(option.name.includes('Basic') && packageId == 616)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose1;
          if(img_num == 3)
            return pose1;
          if(img_num == 4)
            return pose1;
          if(img_num == 5)
            return pose1;
          if(img_num == 6)
            return pose1;
          if(img_num == 7)
            return pose1;
          if(img_num == 8)
            return pose1;
          if(img_num == 9)
            return pose2;
          if(img_num == 10)
            return pose2;
          if(img_num == 11)
            return pose1;
          if(img_num == 12)
            return pose1;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
        if(option.name.includes('School') && packageId == 616)
          {
            if(img_num == 1)
              return pose1;
            if(img_num == 2)
              return pose2;
            if(img_num == 3)
              return pose2;
            if(img_num == 4)
              return pose1;
            if(img_num == 5)
              return pose1;
            if(img_num == 6)
              return pose1;
            if(img_num == 7)
              return pose1;
            if(img_num == 8)
              return pose1;
            if(img_num == 9)
              return pose2;
            if(img_num == 10)
              return pose2;
            if(img_num == 11)
              return pose1;
            if(img_num == 12)
              return pose1;
            if(img_num == 13)
              return pose1;
            if(img_num == 14)
              return pose1;
            if(img_num == 15)
              return 'block';
          }
          if(option.name.includes('8x10') && (packageId == 611 || packageId == 616))
            {
              
                return pose1;
            }
      if(option.name.includes('Star') && packageId == 611)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose2;
          if(img_num == 4)
            return pose1;
          if(img_num == 5)
            return pose1;
          if(img_num == 6)
            return pose1;
          if(img_num == 7)
            return pose1;
          if(img_num == 8)
            return pose1;
          if(img_num == 9)
            return pose1;
          if(img_num == 10)
            return pose1;
          if(img_num == 11)
            return pose1;
          if(img_num == 12)
            return pose2;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
      if(option.name.includes('Memories') && packageId == 611)
        {
          if(img_num == 1)
            return pose2;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose1;
          if(img_num == 4)
            return pose2;
          if(img_num == 5)
            return pose2;
          if(img_num == 6)
            return pose2;
          if(img_num == 7)
            return pose2;
          if(img_num == 8)
            return pose2;
          if(img_num == 9)
            return pose2;
          if(img_num == 10)
            return pose2;
          if(img_num == 11)
            return pose2;
          if(img_num == 12)
            return pose1;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
      if(option.name.includes('Picture') && packageId == 611)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose2;
          if(img_num == 4)
            return pose1;
          if(img_num == 5)
            return pose1;
          if(img_num == 6)
            return pose1;
          if(img_num == 7)
            return pose1;
          if(img_num == 8)
            return pose1;
          if(img_num == 9)
            return pose1;
          if(img_num == 10)
            return pose1;
          if(img_num == 11)
            return pose1;
          if(img_num == 12)
            return pose2;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
      if(option.name.includes('Basic') && packageId == 611)
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose1;
          if(img_num == 3)
            return pose1;
          if(img_num == 4)
            return pose1;
          if(img_num == 5)
            return pose1;
          if(img_num == 6)
            return pose1;
          if(img_num == 7)
            return pose1;
          if(img_num == 8)
            return pose1;
          if(img_num == 9)
            return pose2;
          if(img_num == 10)
            return pose2;
          if(img_num == 11)
            return pose1;
          if(img_num == 12)
            return pose1;
          if(img_num == 13)
            return pose1;
          if(img_num == 14)
            return pose1;
          if(img_num == 15)
            return 'block';
        }
        if(option.name.includes('School') && packageId == 611)
          {
            if(img_num == 1)
              return pose1;
            if(img_num == 2)
              return pose2;
            if(img_num == 3)
              return pose2;
            if(img_num == 4)
              return pose1;
            if(img_num == 5)
              return pose1;
            if(img_num == 6)
              return pose1;
            if(img_num == 7)
              return pose1;
            if(img_num == 8)
              return pose1;
            if(img_num == 9)
              return pose2;
            if(img_num == 10)
              return pose2;
            if(img_num == 11)
              return pose1;
            if(img_num == 12)
              return pose1;
            if(img_num == 13)
              return pose1;
            if(img_num == 14)
              return pose1;
            if(img_num == 15)
              return 'block';
          }
      if(option.name.includes('Ultimate'))
      {
        if(img_num == 1)
          return pose1;
        if(img_num == 2)
          return pose2;
        if(img_num == 3)
          return pose3;
        if(img_num == 4)
          return pose3;
        if(img_num == 5)
          return pose4;
        if(img_num == 6)
          return pose4;
        if(img_num == 7)
          return pose1;
        if(img_num == 8)
          return pose2;
        if(img_num == 9)
          return pose2;
        if(img_num == 10)
          return pose2;
        if(img_num == 11)
          return pose2;
        if(img_num == 12)
          return 'block';
        if(img_num == 13)
          return 'block';
        if(img_num == 14)
          return 'block';
        if(img_num == 15)
          return 'block';
      }
      if(option.name.includes('Scholar'))
        {
          if(img_num == 1)
            return pose1;
          if(img_num == 2)
            return pose2;
          if(img_num == 3)
            return pose3;
          if(img_num == 4)
            return pose4;
          if(img_num == 5)
            return pose1;
          if(img_num == 6)
            return pose2;
          if(img_num == 7)
            return pose2;
          if(img_num == 8)
            return pose2;
          if(img_num == 9)
            return pose2;
          if(img_num == 10)
            return 'block';
          if(img_num == 11)
            return 'block';
          if(img_num == 12)
            return 'block';
          if(img_num == 13)
            return 'block';
          if(img_num == 14)
            return 'block';
          if(img_num == 15)
            return 'block';
        }
        if(option.name.includes('Perfect Pack') && packageId == 610)
          {
            if(img_num == 1)
              return pose3;
            if(img_num == 2)
              return pose2;
            if(img_num == 3)
              return pose2;
            if(img_num == 4)
              return pose2;
            if(img_num == 5)
              return pose2;
            if(img_num == 6)
              return pose2;
            if(img_num == 7)
              return pose2;
            if(img_num == 8)
              return pose2;
            if(img_num == 9)
              return pose2;
            if(img_num == 10)
              return springpose1;
            if(img_num == 11)
              return pose3;
            if(img_num == 12)
              return springpose1;
            if(img_num == 13)
              return springpose2;
            if(img_num == 14)
              return springpose2;
            if(img_num == 15)
              return 'block';
          }
          if(option.name.includes('Just an 8') && packageId == 610)
            {
              if(img_num == 1)
                return pose2;
              
            }
            if(option.name.includes('Just a D') && packageId == 610)
              {
                if(img_num == 1)
                  return pose2;
                
              }
          if(option.name.includes('Basic') && packageId == 610)
            {
              if(img_num == 1)
                return springpose1;
              if(img_num == 2)
                return pose2;
              if(img_num == 3)
                return pose2;
              if(img_num == 4)
                return pose2;
              if(img_num == 5)
                return pose2;
              if(img_num == 6)
                return pose2;
              if(img_num == 7)
                return pose2;
              if(img_num == 8)
                return pose2;
              if(img_num == 9)
                return pose2;
              if(img_num == 10)
                return pose2;
              if(img_num == 11)
                return pose3;
              if(img_num == 12)
                return springpose1;
              if(img_num == 13)
                return springpose2;
              if(img_num == 14)
                return springpose2;
              if(img_num == 15)
                return 'block';
            }
            if(option.name.includes('Digital A') && packageId == 610)
              {
                if(img_num == 1)
                  return pose1;
                if(img_num == 2)
                  return pose3;
                if(img_num == 3)
                  return pose3;
                if(img_num == 4)
                  return pose1;
                if(img_num == 5)
                  return springpose2;
                if(img_num == 6)
                  return springpose1;
                if(img_num == 7)
                  return springpose1;
                if(img_num == 8)
                  return springpose2;
                if(img_num == 9)
                  return pose1;
                if(img_num == 10)
                  return pose3;
                if(img_num == 11)
                  return pose3;
                if(img_num == 12)
                  return pose1;
                if(img_num == 13)
                  return springpose2;
                if(img_num == 14)
                  return springpose1;
                if(img_num == 15)
                  return springpose1;
                if(img_num == 16)
                  return springpose2;
              }
          if(option.name.includes('Something') && packageId == 610)
            {
              if(img_num == 1)
                return springpose1;
              if(img_num == 2)
                return pose2;
              if(img_num == 3)
                return pose2;
              if(img_num == 4)
                return pose2;
              if(img_num == 5)
                return pose2;
              if(img_num == 6)
                return pose2;
              if(img_num == 7)
                return pose2;
              if(img_num == 8)
                return pose2;
              if(img_num == 9)
                return pose2;
              if(img_num == 10)
                return springpose2;
              if(img_num == 11)
                return pose3;
              if(img_num == 12)
                return pose3;
              if(img_num == 13)
                return springpose2;
              if(img_num == 14)
                return springpose2;
              if(img_num == 15)
                return pose3;
              if(img_num == 16)
                return pose3;
            }
        if(option.name.includes('Double Double') && packageId == 610)
          {
            if(img_num == 1)
              return pose3;
            if(img_num == 2)
              return springpose1;
            if(img_num == 3)
              return pose2;
            if(img_num == 4)
              return springpose2;
            if(img_num == 5)
              return pose2;
            if(img_num == 6)
              return pose2;
            if(img_num == 7)
              return pose2;
            if(img_num == 8)
              return pose2;
            if(img_num == 9)
              return pose2;
            if(img_num == 10)
              return springpose1;
            if(img_num == 11)
              return pose3;
            if(img_num == 12)
              return springpose1;
            if(img_num == 13)
              return springpose2;
            if(img_num == 14)
              return springpose2;
            if(img_num == 15)
              return 'block';
          }
        else if (option.name.includes('Senior Special'))
          {
            if(img_num == 1)
              return pose2;
            if(img_num == 2)
              return pose1;
            if(img_num == 3)
              return pose3;
            if(img_num == 4)
              return pose4;
            if(img_num == 5)
              return pose1;
            if(img_num == 6)
              return pose2;
            if(img_num == 7)
              return pose2;
            if(img_num == 8)
              return pose2;
            if(img_num == 9)
              return pose2;
            if(img_num == 10)
              return pose2;
            if(img_num == 11)
              return pose2;
            if(img_num == 12)
              return pose2;
            if(img_num == 13)
              return pose2;
            if(img_num == 14)
              return pose3;
            if(img_num == 15)
              return '49%';
          }
          else if (option.name.includes('Standard Package'))
            {
              if(img_num == 1)
                return pose1;
              if(img_num == 2)
                return pose2;
              if(img_num == 3)
                return pose2;
              if(img_num == 4)
                return pose3;
              if(img_num == 5)
                return pose3;
              if(img_num == 6)
                return pose3;
              if(img_num == 7)
                return pose3;
              if(img_num == 8)
                return pose3;
              if(img_num == 9)
                return pose3;
              if(img_num == 10)
                return pose3;
              if(img_num == 11)
                return pose3;
              if(img_num == 12)
                return pose4;
              if(img_num == 13)
                return pose4;
              if(img_num == 14)
                return pose4;
              if(img_num == 15)
                return pose4;
            }
            else if (option.name.includes('Economy Selection'))
              {
                if(img_num == 1)
                  return pose1;
                if(img_num == 2)
                  return pose1;
                if(img_num == 3)
                  return pose2;
                if(img_num == 4)
                  return pose2;
                if(img_num == 5)
                  return pose2;
                if(img_num == 6)
                  return pose2;
                if(img_num == 7)
                  return pose2;
                if(img_num == 8)
                  return pose2;
                if(img_num == 9)
                  return pose2;
                if(img_num == 10)
                  return pose2;
                if(img_num == 11)
                  return pose3;
                if(img_num == 12)
                  return pose3;
                if(img_num == 13)
                  return pose3;
                if(img_num == 14)
                  return pose3;
                if(img_num == 15)
                  return 'none';
              }
      
      return '0%';
    }
    const findWatermark = (img_num) => {
      var cur_pose = findPose(img_num)
      if (cur_pose.includes('.jpg'))
        return horizWatermarkImage;
     
      return watermarkImage;
      
    }
    //economy 19 image styles or 14
    //standard 20 or 15
    //scholars choice 48 or 9
    //senior special 37  or 9
    //ultimate collection 48 or 9

    const [Style1, setStyle1] = useState({
      position: 'absolute',
      top: findTop(1),
      left: findLeft(1),
      width: findWidth(1),
      zIndex: 0,
      display: findDisplay(1),
    });

    const [Style2, setStyle2] = useState({
      position: 'absolute',
      top: findTop(2),
      left: findLeft(2),
      width: findWidth(2),
      zIndex: 0,
      display: findDisplay(2),
    });

    const [Style3, setStyle3] = useState({
      position: 'absolute',
      top: findTop(3),
      left: findLeft(3),
      width: findWidth(3),
      zIndex: 0,
      display: findDisplay(3),
    });

    const [Style4, setStyle4] = useState({
      position: 'absolute',
      top: findTop(4),
      left: findLeft(4),
      width: findWidth(4),
      zIndex: 0,
      display: findDisplay(4),
    });


    const [Style5, setStyle5] = useState({
      position: 'absolute',
      top: findTop(5),
      left: findLeft(5),
      width: findWidth(5),
      zIndex: 0,
      display: findDisplay(5),
    });

    const [Style6, setStyle6] = useState({
      position: 'absolute',
      top: findTop(6),
      left: findLeft(6),
      width: findWidth(6),
      zIndex: 0,
      display: findDisplay(6),
    });

    const [Style7, setStyle7] = useState({
      position: 'absolute',
      top: findTop(7),
      left: findLeft(7),
      width: findWidth(7),
      zIndex: 0,
      display: findDisplay(7),
    });

    const [Style8, setStyle8] = useState({
      position: 'absolute',
      top: findTop(8),
      left: findLeft(8),
      width: findWidth(8),
      zIndex: 0,
      display: findDisplay(8),
    });

    const [Style9, setStyle9] = useState({
      position: 'absolute',
      top: findTop(9),
      left: findLeft(9),
      width: findWidth(9),
      zIndex: 0,
      display: findDisplay(9),
    });
    const [Style10, setStyle10] = useState({
      position: 'absolute',
      top: findTop(10),
      left: findLeft(10),
      width: findWidth(10),
      zIndex: 0,
      display: findDisplay(10),
    });

    const [Style11, setStyle11] = useState({
      position: 'absolute',
      top: findTop(11),
      left: findLeft(11),
      width: findWidth(11),
      zIndex: 0,
      display: findDisplay(11),
    });

    const [Style12, setStyle12] = useState({
      position: 'absolute',
      top: findTop(12),
      left: findLeft(12),
      width: findWidth(12),
      zIndex: 0,
      display: findDisplay(12),
    });

    const [Style13, setStyle13] = useState({
      position: 'absolute',
      top: findTop(13),
      left: findLeft(13),
      width: findWidth(13),
      zIndex: 0,
      display: findDisplay(13),
    });

    const [Style14, setStyle14] = useState({
      position: 'absolute',
      top: findTop(14),
      left: findLeft(14),
      width: findWidth(14),
      zIndex: 0,
      display: findDisplay(14),
    });


    const [Style15, setStyle15] = useState({
      position: 'absolute',
      top: findTop(15),
      left: findLeft(15),
      width: findWidth(15),
      zIndex: 0,
      display: findDisplay(15),
    });

    const [Style16, setStyle16] = useState({
      position: 'absolute',
      top: findTop(16),
      left: findLeft(16),
      width: findWidth(16),
      zIndex: 0,
      display: findDisplay(16),
    });

  

  return (
    <div>
    <div className="image-container">
      <img src={findBackground(1)}  style={Style1} />
      <img src={findPose(1)}  style={Style1} />
      <img src={findWatermark(1)} alt="Watermark" style={Style1} />

      <img src={findBackground(2)}  style={Style2} />
      <img src={findPose(2)}  style={Style2} />
      <img src={findWatermark(2)} alt="Watermark" style={Style2} />

      <img src={findBackground(3)}  style={Style3} />
      <img src={findPose(3)}  style={Style3} />
      <img src={findWatermark(3)} alt="Watermark" style={Style3} />

      <img src={findBackground(4)}  style={Style4} />
      <img src={findPose(4)}  style={Style4} />
      <img src={findWatermark(4)} alt="Watermark" style={Style4} />

      <img src={findBackground(5)}  style={Style5} />
      <img src={findPose(5)}  style={Style5} />
      <img src={findWatermark(5)} alt="Watermark" style={Style5} />

      <img src={findBackground(6)}  style={Style6} />
      <img src={findPose(6)}  style={Style6} />
      <img src={findWatermark(6)} alt="Watermark" style={Style6} />

      <img src={findBackground(7)}  style={Style7} />
      <img src={findPose(7)}  style={Style7} />
      <img src={findWatermark(7)} alt="Watermark" style={Style7} />

      <img src={findBackground(8)}  style={Style8} />
      <img src={findPose(8)}  style={Style8} />
      <img src={findWatermark(8)} alt="Watermark" style={Style8} />

      <img src={findBackground(9)}  style={Style9} />
      <img src={findPose(9)}  style={Style9} />
      <img src={findWatermark(9)} alt="Watermark" style={Style9} />

      <img src={findBackground(10)}  style={Style10} />
      <img src={findPose(10)}  style={Style10} />
      <img src={findWatermark(10)} alt="Watermark" style={Style10} />

      <img src={findBackground(11)}  style={Style11} />
      <img src={findPose(11)}  style={Style11} />
      <img src={findWatermark(11)} alt="Watermark" style={Style11} />

      <img src={findBackground(12)}  style={Style12} />
      <img src={findPose(12)}  style={Style12} />
      <img src={findWatermark(12)} alt="Watermark" style={Style12} />

      <img src={findBackground(13)}  style={Style13} />
      <img src={findPose(13)}  style={Style13} />
      <img src={findWatermark(13)} alt="Watermark" style={Style13} />

      <img src={findBackground(14)}  style={Style14} />
      <img src={findPose(14)}  style={Style14} />
      <img src={findWatermark(14)} alt="Watermark" style={Style14} />

      <img src={findBackground(15)}  style={Style15} />
      <img src={findPose(15)}  style={Style15} />
      <img src={findWatermark(15)} alt="Watermark" style={Style15} />

      <img src={findBackground(16)}  style={Style16} />
      <img src={findPose(16)}  style={Style16} />
      <img src={findWatermark(16)} alt="Watermark" style={Style16} />
      
    </div>
    </div>
  );
};

export default AbsolutePosImgs;
